import React, {useContext, useState, useEffect, useRef} from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import * as constant from "../../constants/Constant";
import axios from "axios";
import moment from 'moment';
import Button from "../../components/Button/Button";
import RadioCard from "../../components/RadioCard/RadioCard";
import RadioGroup from "../../components/RadioGroup/RadioGroup";
import Loader from "../../components/Loader/Loader";
import UpdateAddress from "./Update/UpdateAddress";
import UpdateContact from "./Update/UpdateContact";
import ButtonGroupRn from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import {Toast, Col, Row} from "react-bootstrap";
import { PaymentMethodItem, PaymentMethodList } from "../../components/PaymentMethod";
import useAlert from "../../services/useAlert";
import { Popover, IconButton, Typography, Box } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import {
  CURRENCY,
  logoutuser,
  checkAuthError,
  RIELCURRENCY,
  US_RIEL_EXCHANGE
} from "../../helper/constant";
import { Scrollbars } from "react-custom-scrollbars";
import CheckoutWrapper, {
  CheckoutContainer,
  CheckoutInformation,
  InformationBox,
  DeliverySchedule,
  Heading,
  SubHeading,
  ButtonGroup,
  CheckoutSubmit,
  CouponBoxWrapper,
  CouponCode,
  CartWrapper,
  CalculationWrapper,
  OrderInfo,
  Title,
  ItemsWrapper,
  Items,
  ItemInfo,
  Price,
  PriceEach,
  TextWrapper,
  Text,
  Bold,
  NoProductMsg,
  ButtonApply,
  ButtonRemove,
  OrderBox,
  ItemImageContainer,
  ItemInfoWrapper,CounterBox, CounterButton, CounterValue,DeleteButton,
  ScrollBarsWrapper,
  HistoryCardsWrapper,
  DeliveryOptionsWrapper,
  OosOptionsWrapper,
  CouponListWrapper,
  CouponCodeItem,
} from "./CheckoutWithSidebar.style";
import { Spinner } from "react-bootstrap";

import {Plus, Minus, CloseIcon} from "../../components/AllSvgIcon";

import Sticky from "react-stickynode";
import { HeaderContext } from "../../contexts/header/header.context";

import { ProfileContext } from "../../contexts/profile/profile.context";
import { useCart } from "../../contexts/cart/use-cart";
// The type of props Checkout Form receives
import Animation from "react-lottie";
import anim from "../../assets/icons/success-tick.json";
import { Modal, Card, ListGroup } from "react-bootstrap";
import TextField from "../../components/TextField/TextField";

import API from "../../network/dashboardAPI";
import AvailableDeliverySlotCheckoutPage from "../../components/AvailableDeliverySlotCheckoutPage/AvailableDeliverySlotCheckoutPage";
import expressService from "../../services/expressService";
import Form from "react-bootstrap/Form";
import checkoutService from "../../services/checkoutService";
import SimpleMessageDialog from "../../components/SimpleMessageDialog/SimpleMessageDialog";

import cashIcon from "../../assets/icons/cash.png";

import CheckoutFormV2 from "../../components/PayWay/CheckoutFormV2";
import PickupPointsMap from "../../components/PickupPointsMap/PickupPointsMap";
import t from "../../i18n/translate";
import reactStringReplace from "react-string-replace";
import itemToCartService from "../../services/itemToCartService";

import RED_API from "../../network/redAPI";
import IconStore from "../../assets/icons/IconStore";
import IconAlarm from "../../assets/icons/IconAlarm";
import ItemSupplierClose from "./ItemSupplierClose";
import styled from "styled-components";
import { logPurchase,logShippingInfo,logPaymentInfo, logPurchaseOnOnlinePayment } from "../../services/googleAnalytics";
import { fetchIPData } from "../../services/checkIP";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import DialogComponent from "../../components/Modal/DialogComponent";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import { FormControl, FormControlLabel, Radio,RadioGroup as MRadioGroup, withStyles, Divider } from "@material-ui/core";
import { CurrencyFormat } from "../../util/currencyFormat";
import CustomerAddress from "../../components/CustomerAddress/CustomerAddress";
import {usePayment} from "../../services/usePayment";

//styled component
const CustomRadio = withStyles({
  root: {
    color: "gray",
    '&$checked': {
      color: "#9cc54b",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
const DivTitleBusinessHours = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 600px) {
    border: none !important;
    .m-0-mobile{
      margin: 0 !important;
    }
  }

  @media screen and ( min-width: 768px) and (max-width: 1225px) {
    border: none !important;
    .m-0-mobile{
      margin: 0 !important;
    }
  }
`;
const TitleBusinessHours = styled.span`
  font-size: 16px;
  line-height: 1.2;
  @media (max-width: 320px) {
    font-size: 14px !important;
  }
  @media screen and (max-width: 600px) {
    display: none !important;
  }
  @media screen and ( min-width: 768px) and (max-width: 1225px) {
    display: none !important;
  }
`;
const TitleRemark = styled.p`
  font-size: 14px;
  display: block;
  @media only screen and (max-width: 468px) {
   font-size: 12px !important;
  }
`;

const EarnPromotionBadge = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 0;
  color: #4b4b4b;
  width: 100%;

  .promotion-text {
    font-weight: 500;
    padding-left: 6px;
    font-size: 13px;
  }
`;

const EarnPromotionTooltipWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: pointer;

  .info-icon {
    font-size: 18px;
    color: #999;
    transition: color 0.2s ease;
  }

  .tooltip-text {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    padding: 8px 12px;
    border-radius: 8px;
    white-space: nowrap;
    z-index: 100;
    pointer-events: none;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-width: 6px;
      border-style: solid;
      border-color: #333 transparent transparent transparent;
    }
  }

  &:hover .info-icon {
    color: #666;
  }

  &:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }
`;

//item component
const OrderItem = ({product, props, address_id, modify_total, cartType, setWalletChecked, setDelipointsChecked, setTotalWalletAmount, walletChecked , setPaymentMethod, setUpdateOrder, setRemoveProduct, slotValidate, itemsRedeemChecked}) => {
  const { id, quantity, title, name, unit, price, salePrice } = product;
  const { updateItem, carttotal, items, clearCart, fetchOrderItems, removeItemFromCart } =
    useCart();
  const itemImageUrl = product.store_item_infos[0].default_image_url;
  const [show, setShow] = useState(false);
  const [newquantity, setNewQuantity] = useState(product.quantity);
  const [updating, setUpdating] = useState(false);
  const [msg, setMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [productQuantity, setProductQuantity] = useState(product.quantity)

  const history = useHistory()
  const displayPrice = product.item_price;

  useEffect(() => {
    setUpdating(true);
    setProductQuantity(product.quantity)
  }, [product.quantity]);


  useEffect(() => {
    setUpdating(false);
    let user = localStorage.getItem("user");
    let parsedUser = JSON.parse(user);
    modify_total();
    if( localStorage.getItem("order_id") === undefined ){
      alert(t("shop_checkout_order_not_exist", false));
    }
  }, [carttotal]);

  const quantityFormDialog = async (e, product, newquantity) => {
    e.preventDefault();
    if (parseInt(newquantity) === parseInt(product.quantity ?? 0)) {
      return
    }

    const existingRedeemQty = parseInt(product.dp_redeem_quantity ?? 0);
    // input is total; derive normal qty for the API
    const newNormalQty = Math.max(parseInt(newquantity) - existingRedeemQty, 0);

    setUpdating(true);
    if (newNormalQty >= 1 || (newNormalQty === 0 && existingRedeemQty > 0)) {
      let body = {
        store_id: 1,
        item_id: product["item_id"],
        type: cartType === "express" ? 1 : 0,
        quantity: newNormalQty,
        is_redeem_payment: existingRedeemQty > 0 ? 1 : null,
        dp_redeem_quantity: existingRedeemQty > 0 ? existingRedeemQty : null,
      };
      await handleSubmit(body);
      await fetchOrderItems(cartType, slotValidate);
    } else {
      setUpdating(false);
      handleRemoveProduct(e, product)
    }
  };

  const handleCounterValueKeyDown = async (event, product, newquantity) =>{
    if(event.key === 'Enter'){
      quantityFormDialog(event, product, newquantity)
    }
  }

  const handleRemoveProduct = async (e, product) => {
    e.preventDefault();
    e.stopPropagation();

    let response = window.confirm( t('home_basket_alert_remove_item', false))
    if(response){
      let tepTotal = carttotal-(product.item_price*product.quantity)
      setIsLoading(true);
      if (!localStorage.getItem("user")) {
        document.getElementById("joinBTn").click();
      } 
      else{
        await removeItemFromCart(product, cartType)
          .then(setUpdateOrder(true))
          .then(setRemoveProduct(true))

      }

      if(tepTotal< 10){
        if (cartType === "normal") {
          history.push("/");
        } else {
          history.push("/express");
        }
      }
      setIsLoading(false);
    }else{
      setProductQuantity(product.quantity)
    }
  }

  const handleIncQuantity = async (e, product) => {
    e.preventDefault();
    e.stopPropagation();

    setUpdating(true);
    setIsLoading(true);
    if(!localStorage.getItem("user")){
      document.getElementById("joinBTn").click();
    }
    else {
      if(!isLoading) {
        const existingRedeemQty = parseInt(product.dp_redeem_quantity ?? 0);
        const currentNormalQty = parseInt(product.quantity ?? 0) - existingRedeemQty;
        const hasDpPromo = parseFloat(product.store_item_infos[0]?.dp_price ?? 0) > 0;

        let body;
        if (hasDpPromo) {
          // dp promo item — increment dp_redeem_quantity
          body = {
            store_id: 1,
            item_id: product["item_id"],
            type: cartType === 'express' ? 1 : 0,
            quantity: currentNormalQty,
            is_redeem_payment: 1,
            dp_redeem_quantity: existingRedeemQty + 1,
            is_auto_apply_redeem_quantity: false,
          };
        } else {
          // regular item — increment normal qty
          body = {
            store_id: 1,
            item_id: product["item_id"],
            type: cartType === 'express' ? 1 : 0,
            quantity: currentNormalQty + 1,
            is_redeem_payment: existingRedeemQty > 0 ? 1 : null,
            dp_redeem_quantity: existingRedeemQty > 0 ? existingRedeemQty : null,
            is_auto_apply_redeem_quantity: false,
          };
        }
        await handleSubmit(body);
        await fetchOrderItems(cartType, slotValidate);
        setIsLoading(false);
      }
    }
  }

  const handleDecQuantity = async (e, product) => {
    e.preventDefault();
    e.stopPropagation();

    setUpdating(true);
    setIsLoading(true);
    if (!localStorage.getItem("user")) {
      document.getElementById("joinBTn").click();
    }
    else {
      if(!isLoading) {
        const existingRedeemQty = parseInt(product.dp_redeem_quantity ?? 0);
        const currentNormalQty = parseInt(product.quantity ?? 0) - existingRedeemQty;

        if (currentNormalQty > 0) {
          if (currentNormalQty === 1 && existingRedeemQty === 0) {
            // last unit, no promo → remove item
            setUpdating(false);
            handleRemoveProduct(e, product);
          } else {
            // decrement normal qty
            const newNormalQty = currentNormalQty - 1;
            let body = {
              store_id: 1,
              item_id: product["item_id"],
              type: cartType === 'express' ? 1 : 0,
              quantity: newNormalQty,
              is_redeem_payment: existingRedeemQty > 0 ? 1 : null,
              dp_redeem_quantity: existingRedeemQty > 0 ? existingRedeemQty : null,
            };
            await handleSubmit(body);
            await fetchOrderItems(cartType, slotValidate);
          }
        } else if (existingRedeemQty > 0) {
          // normal qty is 0 — decrement dp_redeem_quantity instead
          const newRedeemQty = existingRedeemQty - 1;
          if (newRedeemQty === 0) {
            // no units left at all → remove item
            setUpdating(false);
            handleRemoveProduct(e, product);
          } else {
            let body = {
              store_id: 1,
              item_id: product["item_id"],
              type: cartType === 'express' ? 1 : 0,
              quantity: 0,
              is_redeem_payment: 1,
              dp_redeem_quantity: newRedeemQty,
            };
            await handleSubmit(body);
            await fetchOrderItems(cartType, slotValidate);
          }
        } else {
          setUpdating(false);
        }
        setIsLoading(false);
      }
    }
  }

  const handleSubmit = async (body) => {
    const dataResp = await itemToCartService.updateQuantity(body);
    if (dataResp.status !== 200) {
      const pattern = ["multiSupplier", "paymentInProgress"];
      if (pattern.includes(dataResp.data.error)) {
        setMsg(true);
        setShow(false);
        if (!window.confirm(t('shop_checkout_update_cart_error_payment_in_progress'))) {
          setUpdating(false);
          return;
        };
        const orderLockResp = await expressService.orderLocked(cartType);
        if(orderLockResp.status === 200) {
          const response = await itemToCartService.updateQuantity(body);
          if (response.status === 200) {
            await fetchOrderItems(cartType, slotValidate);
          } else {
            alert(response.data.message);
          }
          setUpdating(false);
        } else {
          setUpdating(false);
          alert( t('shop_item_update_error') );
        }
      }
    } else {
      setShow(false);
      setUpdating(false);
      setUpdateOrder(true)
      if (walletChecked) {
        setPaymentMethod('cod');
        setWalletChecked(false);
        setDelipointsChecked(false);
        setTotalWalletAmount(props.wallet.amount);
      }
    }
  };
  
  return (
    <>
      <Items 
        key={product.item_id}
        style={{
          padding: "0px 10px"
        }}
      >
        <Modal
          show={updating}
          onHide={() => {
            setUpdating(false);
          }}
          // dialogClassName="modal-lg"
          aria-labelledby="example-custom-modal-styling-title"
          size="sm"
          animation={true}
          centered
          backdrop="static"
        >
          {/* <Animation options={defaultOptions} height={180} width={180} /> */}
          <div
            style={{
              fontSize: 20,
              textAlign: "center",
              margin: 10,
              marginTop: 18,
              color: "#222",
            }}
          >
            {t("shop_checkout_update_cart")}
          </div>
        </Modal>
        
        <ItemImageContainer>
          <img
            src={itemImageUrl ? itemImageUrl : require('../../assets/images/delishop-favicons.png') }
            alt={product.item_name ? product.item_name : title}
          />
        </ItemImageContainer>
        <div className="item-info">
          <div className="d-flex justify-content-start align-items-center">
            <ItemInfoWrapper>
              <div className="product_name" style={{fontSize: "18px"}}>{product.item_name ? product.item_name : title} </div>
              <ItemInfo>
                Sku {product.store_item_infos[0].product_code}
                {/* ({product.item_price_name}) */}
              </ItemInfo>
            </ItemInfoWrapper>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <PriceEach >
              <p className="d-flex align-items-end">
              <div className="d-flex flex-column">
              {product.store_item_infos[0].promo === 1 && product.promo_start_date !== null && product.promo_end_date !== null && constant.compDate(product.store_item_infos[0].promo_start_date, product.store_item_infos[0].promo_end_date) ?
                <span className="original-price">{CURRENCY}{product.store_items_price_types[0].price.toFixed(2)} </span>
                : null
                }
                <span>{CURRENCY}{displayPrice.toFixed(2)} </span>
              </div>
              / Each</p>
              </PriceEach>
            <div className="d-flex justify-content-between align-items-center">
              <CounterBox>
                <CounterButton className="minus circle" onClick={(e) => handleDecQuantity(e, product)}>
                    <Minus />
                </CounterButton>
                <CounterValue 
                  // min='1'
                  onChange={(e) => {
                    setProductQuantity(e.target.value);
                  }}
                  onBlur={(e)=>{
                    quantityFormDialog(e, product, e.target.value);
                  }}
                  onKeyDown={(e)=>{handleCounterValueKeyDown(e, product, e.target.value);
                  }}
                  value={productQuantity}
                  >
                </CounterValue>
                <CounterButton className="plus circle" onClick={(e) =>handleIncQuantity(e, product)}>
                    <Plus />
                </CounterButton>
              </CounterBox>
              <DeleteButton onClick={(e) =>  handleRemoveProduct(e, product)}>
                <DeleteOutlineIcon />
              </DeleteButton>
            </div>
            <div className="d-flex flex-column">
              <Price className="riel">
              {Math.ceil((displayPrice * quantity) * US_RIEL_EXCHANGE)} {RIELCURRENCY}
              </Price>
              <Price className={`${cartType}`}>
                <h5>
                {CURRENCY}
                  {(displayPrice * quantity).toFixed(2)}
                </h5>
              </Price>
            </div>
            <div style={{ minWidth: "60px", display: "flex", flexDirection: "column", alignItems: "center", gap: "5px" }}>
              {product.dp_redeem_quantity > 0 && itemsRedeemChecked && parseFloat(product.store_item_infos[0]?.dp_price ?? 0) > 0 && (
                <span style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <CardGiftcardIcon style={{ fontSize: "27px", color: "#545454ff" }} />
                  <span style={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                    - {product.dp_redeem_quantity * product.store_item_infos[0].dp_points}
                  </span>
                  <span style={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                    - ${(parseFloat(product.dp_discount_payment ?? 0) > 0 ? parseFloat(product.dp_discount_payment) : (parseFloat(product.item_price ?? 0) - parseFloat(product.store_item_infos[0]?.dp_price ?? 0)) * parseInt(product.dp_redeem_quantity ?? 0)).toFixed(2)}
                  </span>
                </span>
              )}
              {product.store_item_infos[0].dp_earn_promotions && product.store_item_infos[0].dp_earn_promotions.length > 0 && (
                product.store_item_infos[0].dp_earn_promotions
                  .filter(promo => promo.is_active && constant.compDate(promo.start_date, promo.end_date))
                  .map((promo, index) => (
                    <span key={promo.id || index} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <CardGiftcardIcon style={{ fontSize: "27px", color: "#545454ff" }} />
                      <span style={{ fontSize: "11px", fontWeight: 600, whiteSpace: "nowrap" }}>
                        {promo.points_multiplier
                          ? `+ ${Math.round((promo.points_multiplier - 1) * 100)}%`
                          : `+ ${promo.fixed_points_multiple_use ? promo.fixed_points * quantity : promo.fixed_points}`
                        }
                      </span>
                    </span>
                  ))
              )}
            </div>
          </div>
        </div>
      </Items>
    </>
  );
};

//checkout layout
const CheckoutWithSidebar = ({ token, deviceType, props }) => {
	const Alert = useAlert();
  const [hasCoupon, setHasCoupon] = useState(false);
  const [couponId, setCouponId] = useState(0);
  const [searchCoupon, setSearchCoupon] = useState("");
  const [paymentMethod, setPaymentMethod] = useState();
  const [tid, setTid] = useState("");
  const [couponError, setError] = useState("");
  const [twodslots, settwodslots] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const { state, dispatch } = useContext(ProfileContext);
  const {
    items,
    isShopOpen,
    supplierClose,
    remark,
    remark_body,
    carttotal,
    removeCoupon,
    // coupon,
    applyCoupon,
    clearCart,
    cartItemsCount,
    calculatePrice,
    fetchOrderItems,
    calculateDiscount,
    calculateSubTotalPrice,
    isRestaurant,
    toggleRestaurant,
    addItem,
    removeItem,
    updateItem,
  } = useCart();

  const hasRedeemItems = (items ?? []).some(item => parseInt(item.dp_redeem_quantity ?? 0) > 0);

  const itemsRedemptionAmount = (items ?? []).reduce((sum, item) => {
    const redeemQty = parseInt(item.dp_redeem_quantity ?? 0);
    if (redeemQty === 0) return sum;
    const dpDiscountPayment = parseFloat(item.dp_discount_payment ?? 0);
    if (dpDiscountPayment > 0) return sum + dpDiscountPayment;
    // fallback: (item_price − dp_price) × dp_redeem_quantity
    const itemPrice = parseFloat(item.item_price ?? 0);
    const dpPrice = parseFloat(item.store_item_infos?.[0]?.dp_price ?? 0);
    return sum + (itemPrice - dpPrice) * redeemQty;
  }, 0);

	//use payment
	const {
		addFallbackMethods,
		isPaymentRequesting,
	} = usePayment()
  const [loading, setLoading] = useState(false);
  const [isInvalid, setIsInvalid] = useState({
    isTrue: false,
    msg: "",
  });
  const { address, contact, card, schedules } = state;
  const { headerState } = useContext(HeaderContext);
  const [isChecked, setChecked] = useState(0);
  const [oosoption, setOOSOption] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(0);
  const [selectedSlot, setSelectedSlot] = useState(0);
  const [grossTotal, setGrossTotal] = useState(0.0);
  const [modalshow, setModalShow] = useState(false);
  const [comment, setComment] = useState("");
  const [show, setShow] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
	const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [discount, setDiscount] = useState(0);
  const [allSLOTS, setAllSlots] = useState([]);
  const [showSchedule, setShowSchedule] = useState(false);
  const [selfdelivery, setSelfDelivery] = useState(0);
  const [selectedPickupPoint, setSelectedPickupPoint] = useState(null);
  const [showSlot, setShowSlot] = useState(true);
  const [showError, setShowError] = useState(false);
  const [dialogHeaderLabel, setDialogHeaderLabel] = useState("");
  const [errorMessage, setErrorMessage] = useState(
    t("shop_checkout_out_of_rang", false)
  );
  const [isError, setIsError] = useState(null);
  const [addressIsInRange, setAddressIsInRange] = useState(null);
  const [hideCashOnDelivery, setHideCashOnDelivery] = useState(true);
  const [hidePaymentOnlineOnDelivery, setHidePaymentOnlineOnDelivery] =
    useState(true);
  const [codMethodData, setCodMethodData] = useState(null);
  const [codInfoAnchorEl, setCodInfoAnchorEl] = useState(null);

  // Payemnt modal
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [checkedABAPay, setCheckedABAPay] = useState(false);
  const [checkedBakong, setCheckedBakong] = useState(false);
  const [checkedCard, setCheckedCard] = useState(false);
  const [checkedDelivery, setCheckedDelivery] = useState(false);
  const [walletChecked, setWalletChecked] = useState(false);
  const [delipointsChecked, setDelipointsChecked] = useState(false);
  const [itemsRedeemChecked, setItemsRedeemChecked] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [contacted, setContacted] = useState(false);
  const handlePaymentClose = () => setShowPaymentModal(false);
  const handlePayemntShow = () => setShowPaymentModal(true);
  const [checkout_banner, setCheckoutBanner] = useState();
  const [checkoutLink, setCheckoutLink] = useState();
  const [cartType, setCartType] = useState("normal");
  const isExpress = localStorage.getItem("expressMode") ? "express" : "normal";
  const [deliveryColor, setDeliveryColor] = useState("#9cc54b");
  const [checkPaymentIntervalId, setCheckPaymentIntervalId] = useState(null);
  const [selectedAddressToUpdate, setSelectedAddressToUpdate] = useState(null);
	const [externalCourier, setExternalCourier] = useState(true);
  //Pay Online 
  const [isPayOnline, setIsPayOnline] = useState(false);

  const [updateOrder, setUpdateOrder] = useState(false); //check if just update order reset coupon
  const [removeProduct, setRemoveProduct] = useState(false);

  // Visa/Master Card Dialog  
  const [showDialog, setShowDialog] = useState(false);
  const [historyCard, setHistoryCard] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isOldCardExpired, setIsOldCardExpired] = useState(false);
  const [cardToken, setCardToken] = useState("");
  const [cardLoading, setCardLoading] = useState(false);
  const [oldCardLoading, setOldCardLoading] = useState(false);
  let isNewCard = false;

  const handleChangeVisaOldCard = (index) => {
    setSelectedIndex(index);
    setCardToken(historyCard[index].card_token);
    setIsOldCardExpired(false);
  };

  // Payment with Kess
  let selectedPayment = [
    false,
    false,
    false,
    false,
    false,
    false,
    false
  ]
  const [listPaymentMethod, setListPaymentMethod] = useState([])
  const [listCheckPayment, setListCheckPayment] = useState(selectedPayment)
  const [isLoadingPaymentMethods, setIsLoadingPaymentMethods] = useState(false);
  //Wallet amount remain
  const [totalWalletAmount, setTotalWalletAmount] = useState(0);
  const [isDisplayWallet, setIsDisplayWallet] = useState(false);
  const [isDisplayDelipoints, setIsDisplayDelipoints] = useState(false);
  // Delipoints
  const [dpBalance, setDpBalance] = useState(0);
  const [dpTier, setDpTier] = useState(null);
  const [dpSettings, setDpSettings] = useState({});
  const [dpRedemptionValue, setDpRedemptionValue] = useState(0);
  const [kessPayment,setKessPayment] = useState();
  const history = useHistory();

  // Custom handlers to bridge new components with existing state
  const handleSelectPaymentMethod = (method) => {
    // Set the BIC code for online payment - this is what the backend uses
    setSelectedPaymentType(method.bic);

    // Find the index of this payment method in the kessPayment array
    const methodIndex = kessPayment?.findIndex(bic => bic === method.bic);

    // Update paymentMethod based on BIC to route to correct payment flow
    if (method.bic === "ABA_PAY" || method.bic === "ABAAKHPP") {
      // ABA payments - special handling at line 1470
      setPaymentMethod("");
    } else if (methodIndex !== -1 && methodIndex !== undefined) {
      // Kess payment methods - use numeric string index for condition at line 1493
      setPaymentMethod(methodIndex.toString());
    } else {
      // Fallback for other online payments (KHQR, VISA, MASTERCARD, etc.)
      // Set to "abapay" to match the check at line 1481: ["card", "abapay", "bakong"]
      setPaymentMethod("abapay");
    }

    setCheckedDelivery(false); // Uncheck COD
  };

  const handleSelectCOD = () => {
    // Clear online payment selection when COD is selected
    setSelectedPaymentType("");
    // Set payment method to COD
    setPaymentMethod("cod");
    setCheckedDelivery(true);
  };

  const handleCODInfoClick = (e) => {
    e.stopPropagation(); // Prevent selection when clicking info icon
    setCodInfoAnchorEl(e.currentTarget);
  };

  const handleCODInfoClose = () => {
    setCodInfoAnchorEl(null);
  };

  const codInfoOpen = Boolean(codInfoAnchorEl);

  const getPaymentMethodCode = () => {
    // Use selectedPaymentType (BIC code) for online payments, or CASH for COD
    return selectedPaymentType || (paymentMethod === "cod" ? "CASH" : null);
  };

  const [slotValidate, setSlotValidate] = useState(null);
  const [openModalHours, setOpenModalHours] = useState(false);
  const [normalOpenHours, setNormalOpenHours] = useState([]);
  const [itemForToday, setItemForToday] = useState({})
	const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
  const lang = localStorage.getItem("lang") || "en";

	useEffect(() => {
    const openBasket = setTimeout(async() => {
      const response = await RED_API.CheckBasket(cartType === "express" ? 1 : 0);
      const data = await response.json();
      if(!data.isLocked) return;
      const orderLockResp = await expressService.orderLocked(cartType);
      if(orderLockResp.status !== 200) return;
    }, 1000);
    return () => {
      clearTimeout(openBasket);
    }
	}, [cartType]);

  useEffect(() => {
    if (
      props.wallet !== null &&
      typeof props.wallet.amount !== "undefined" &&
      props.wallet.amount !== 0
    ) {
      setTotalWalletAmount(props.wallet.amount);
      setIsDisplayWallet(true);
    } else {
      setTotalWalletAmount(0);
    }
  }, [props.wallet]);

  useEffect(() => {
    const data = props.delipoints?.data;
    if (data) {
      setDpBalance(data.dpBalance ?? 0);
      setDpTier(data.tier ?? null);
      setIsDisplayDelipoints(((data.dpBalance ?? 0) > 0));
    } else {
      setIsDisplayDelipoints(false);
    }
  }, [props.delipoints]);

  // Fetch delipoints settings (payment_value_per_point, minimum_redemption, etc.)
  useEffect(() => {
    const fetchDpSettings = async () => {
      try {
        const token = localStorage.getItem("token");
        const resp = await axios.get(
          `${constant.baseUrl}api/v1/delipoints/customer/setting/list`,
          { headers: { Authorization: token } }
        );
        if (resp.status === 200 && resp.data.success) {
          const map = {};
          resp.data.data.forEach(s => { map[s.setting_key] = s.setting_value; });
          setDpSettings(map);
        }
      } catch (e) {
        console.error("Failed to fetch delipoints settings", e);
      }
    };
    fetchDpSettings();
  }, []);

  // Auto-set itemsRedeemChecked based on whether any cart items have active redemptions
  useEffect(() => {
    setItemsRedeemChecked(hasRedeemItems);
  }, [hasRedeemItems]);

  // Recalculate delipoints redemption value whenever anything that affects the cap changes,
  // including grossTotal (which picks up delivery fee once it loads)
  useEffect(() => {
    setDpRedemptionValue(calcDelipointsAmount());
  }, [dpBalance, dpSettings, items, delipointsChecked, itemsRedeemChecked, grossTotal, walletChecked, props.wallet]);

  // Auto-uncheck extra DeliPoints if nothing is left to pay after promo + wallet.
  // Guard: skip until delivery charge is loaded so grossTotal is final.
  useEffect(() => {
    if (props.deliveryCharge === undefined) return;
    const remaining = Math.max(
      grossTotal
        - (itemsRedeemChecked ? itemsRedemptionAmount : 0)
        - (walletChecked && props.wallet ? (props.wallet.amount ?? 0) : 0),
      0
    );
    if (remaining <= 0) setDelipointsChecked(false);
  }, [grossTotal, itemsRedeemChecked, itemsRedemptionAmount, walletChecked, props.wallet, props.deliveryCharge]);

  /**
   * Calculate how much USD value the customer's delipoints are worth,
   * and how many points are actually consumed.
   *
   * Guards:
   *   - Returns zero if dpBalance is 0 or negative.
   *   - Returns zero if payment_value_per_point is not configured.
   *   - Returns zero if dpBalance < minimum_redemption.
   *
   * Promo logic (Step 1 — per dp-promo item):
   *   For each cart item with an active dp promo window:
   *     - savingsPerUnit = dp_price  (the dp covers the full dp_price cash cost)
   *     - The customer spends dp_points and pays $0 cash for that unit.
   *     - The cart total is reduced by dp_price per unit redeemed.
   *
   *   Breakdown per unit:
   *     base price  – regular promo savings – dp savings = customer cash cost
   *     $11         – $3.50                – $6.00       = $1.50  ← customer pays $1.50 cash
   *     Wait — actually dp covers dp_price ($6), so:
   *     Customer pays: 200 dp points + $0 cash for this unit (item cost covered = $6)
   *
   * Order-level (Step 2):
   *   Remaining balance is used at payment_value_per_point rate to offset the rest.
   *
   * Example: base=$11, promo=$7.5, dp_price=$6, dp_points=200, qty=1,
   *          grossTotal=$38.46, balance=1000, min_redemption=100
   *   → Step 1: 200 pts spent, cart reduced by $6  (balance: 1000→800)
   *   → Step 2: 800 pts × $0.01 = $8.00 off remaining $32.46
   *   → total dp discount: $6 + $8 = $14, points used: 1000
   *
   * Returns { usdValue: number, pointsUsed: number }
   */
  const calcDelipointsResult = () => {
    if (!dpBalance || dpBalance <= 0) return { usdValue: 0, pointsUsed: 0 };

    const valuePerPoint     = parseFloat(dpSettings?.payment_value_per_point ?? 0);
    const minimumRedemption = parseFloat(dpSettings?.minimum_redemption ?? 0);

    if (valuePerPoint <= 0) return { usdValue: 0, pointsUsed: 0 };
    if (minimumRedemption > 0 && dpBalance < minimumRedemption) return { usdValue: 0, pointsUsed: 0 };

    const itemPts = itemsRedeemChecked
      ? (items ?? []).reduce((sum, item) => sum + parseFloat(item.store_item_infos?.[0]?.dp_points ?? 0) * parseInt(item.dp_redeem_quantity ?? 0), 0)
      : 0;
    const remainingPoints = Math.max((dpBalance ?? 0) - itemPts, 0);

    let remainingTotal = grossTotal;
    if (itemsRedeemChecked) {
      remainingTotal = Math.max(remainingTotal - itemsRedemptionAmount, 0);
    }
    if (walletChecked && props.wallet !== null) {
      remainingTotal = Math.max(remainingTotal - (props.wallet?.amount ?? 0), 0);
    }

    const maxUsdValue = parseFloat((remainingPoints * valuePerPoint).toFixed(2));
    const usdValue = parseFloat(Math.min(maxUsdValue, remainingTotal).toFixed(2));
    return { usdValue, pointsUsed: remainingPoints };
  };

  /** Convenience wrapper — returns just the USD redemption value. */
  const calcDelipointsAmount = () => calcDelipointsResult().usdValue;

  const [enableCheckOutButton, setEnableCheckOutButton] = useState(false);
  const placeOrderStatus = useSelector(
    (state) => state.cartReducer.orderPlaced
  );

  // Function to fetch payment methods from V3 API
  const fetchPaymentMethods = () => {
    setIsLoadingPaymentMethods(true);
    const orderId = localStorage.getItem("order_id");

    RED_API.PaymentGateWay({
      service: "webpay.acquire.getpaymentmethods",
	    body: "Delishop",
      order_id: orderId, // Include order_id to check COD restrictions
    })
	    .then(res => res.json())
	    .then(res => {
		    const currentMethods = res?.data?.data || [];
		    const deliveryRange = res?.data?.deliveryRange || { allowPaymentMethod: [] };


		    // Check if COD exists in the API response - simple and dynamic
		    const codMethod = currentMethods.find(method =>
			    method.bic === "CASH" || method.bic?.toUpperCase() === "CASH"
		    );
		    const hasCOD = !!codMethod;

		    // Store COD method data including icon
		    if (codMethod) {
			    setCodMethodData(codMethod);
		    }

		    // Update COD visibility based on V3 API response
		    if (cartType !== "express") {
			    const codAllowed = hasCOD;
			    const onlineAllowed = currentMethods.some(method =>
				    method.bic !== "CASH" && method.bic?.toUpperCase() !== "CASH"
			    );

			    setHideCashOnDelivery(!codAllowed);
			    setHidePaymentOnlineOnDelivery(!onlineAllowed);

			    // Set default payment method based on availability
			    if (!paymentMethod) {
				    if (codAllowed) {
					    setPaymentMethod("cod");
					    setCheckedDelivery(true);
				    } else if (onlineAllowed) {
					    setPaymentMethod("abapay");
					    setCheckedABAPay(true);
				    }
			    } else {
				    // Reset payment method if current selection is not available
				    if (paymentMethod === "cod" && !codAllowed) {
					    setCheckedDelivery(false);
					    setPaymentMethod("abapay");
					    setCheckedABAPay(true);
				    } else if (['abapay', 'card', 'bakong'].includes(paymentMethod) && !onlineAllowed) {
					    setCheckedABAPay(false);
					    setCheckedBakong(false);
					    setCheckedCard(false);
					    setPaymentMethod("cod");
					    setCheckedDelivery(true);
				    }
			    }
		    }

		    // Filter out COD from methods list - it's shown separately in static UI
		    // COD is identified by bic="CASH"
		    const onlineMethodsOnly = currentMethods.filter(method => {
			    const isCOD = method.bic === "CASH" || method.bic?.toUpperCase() === "CASH";
			    return !isCOD; // Keep everything except COD
		    });

		    // Set Kess Payment BICs (including COD for backend processing)
		    const kessPaymentList = currentMethods.map(item => item.bic);
		    setKessPayment(kessPaymentList);

		    // Proceed to fetch fallback methods
		    return RED_API.getPaymentMethods()
			    .then(fallbackRes => fallbackRes.json())
			    .then(fallbackData => {
				    const abaProvider = fallbackData.find(
					    item => item.provider === "ABA_PAY"
				    );
				    const hasAba = onlineMethodsOnly.some(item => item.bic === "ABAAKHPP");

				    let updatedMethods = [...onlineMethodsOnly];

				    if (abaProvider && !hasAba) {
					    const fallbackABA = {
						    title: "ABA",
						    img_url: abaProvider.logo,
						    bic: "ABAAKHPP",
						    storelink: {ios: null, android: null},
					    };
					    updatedMethods = addFallbackMethods(onlineMethodsOnly, [fallbackABA]);
					    // Don't add to kessPayment here since it's already set above
				    }

				    // Only set online payment methods (COD filtered out)
				    setListPaymentMethod(updatedMethods);
				    setIsLoadingPaymentMethods(false);
			    })
			    .catch(fallbackErr => {
				    console.warn("Error fetching fallback methods:", fallbackErr);
				    // Only set online payment methods (COD filtered out)
				    setListPaymentMethod(onlineMethodsOnly);
				    setIsLoadingPaymentMethods(false);
			    });
	    })
	    .catch(err => {
		    console.error("Error fetching payment gateway methods:", err);
		    setIsLoadingPaymentMethods(false);
	    });
  };

	// Fetch payment methods after address is loaded
	// Wait for selectedAddress to be set to ensure proper COD validation
  useEffect(() => {
	  if (selectedAddress && selectedAddress !== 0) {
		  fetchPaymentMethods();
	  }
  }, [selectedAddress]);

	const paymentCreateOrder = (e) => {
    setLoading(true);
    setCardLoading(true);

    // Use the new hook's getPaymentMethodCode() function
    const paymentMethodCode = getPaymentMethodCode();

    if (!paymentMethodCode) {
      console.error("No payment method selected");
      setCardLoading(false);
      setLoading(false);
      return;
    }

    RED_API.PaymentGateWay({
      "service": "webpay.acquire.createorder",
      "order_id": localStorage.getItem("order_id"),
      "body": "Delishop",
      "currency": "USD",
      "setting": {
          "enabled_payment_methods" : [paymentMethodCode]
      }
    }
    ).then((res) => res.json())
      .then((res) => {
        if (res.data.success) {
          window.open(res.data.data.payment_link, "_self");
          const data = {
            item:items,
            data:props.checkoutdata
          }
          localStorage.setItem('order_data',JSON.stringify(data))
          setLoading(false);
        } else {
          window.alert(res.data.message);
          history.push("/");
        }
        setCardLoading(false);
      })
  }

  const paymentWithOldCard = async() => {
    setOldCardLoading(true);
	  setLoading(true);

	  // Use the new hook's getPaymentMethodCode() function
    const paymentMethodCode = getPaymentMethodCode();

    if (!paymentMethodCode) {
      console.error("No payment method selected");
      setOldCardLoading(false);
	    setLoading(false);
	    return;
    }

    await RED_API.PaymentGateWay({
      "service": "webpay.acquire.createorder",
      "order_id": localStorage.getItem("order_id"),
      "body": "Delishop",
      "currency": "USD",
      "setting": {
        "enabled_payment_methods": [paymentMethodCode]
      }
    }).then((res) => res.json())
      .then((res) => {
        if (res.data.success) {
          setCardToken("");

          window.open(constant.WEBPAY_API_URL + res.data.data.token + "/?card_token=" + cardToken, "_self");
	        setLoading(false);
	        const data = {
            item:items,
            data:props.checkoutdata
          }
          localStorage.setItem('order_data',JSON.stringify(data))
        } else {
          window.alert(res.data.message);
          history.push("/");
        }
        setOldCardLoading(false);
      }).catch((error) => {
        console.error(error);
		    setLoading(false);
	    });
  }

  useEffect(() => {
    API.getBannerImages()
      .then((res) => res.json())
      .then((res) => {
        setCheckoutBanner(res.data[0].checkout);
        setCheckoutLink(res.data[0].checkoutLink);
      });
  }, []);

  const paymentOptionChoose = async (value) => {
    setIsInvalid({ isTrue: false, msg: "" });

    if (value !== "wallet") {
      setPaymentMethod(value);
    }
    listCheckPayment.fill(false)
    listCheckPayment[value] = true
    setListCheckPayment(listCheckPayment)
    setCheckedCard(false);
    setCheckedABAPay(false);
    setCheckedDelivery(false);
    setCheckedBakong(false);

    if (value === "cod") {
      setCheckedCard(false);
      setCheckedABAPay(false);
      setCheckedDelivery(true);
      setCheckedBakong(false);
    } else if (value === "wallet") {
      setCheckedCard(false);
      setCheckedABAPay(false);
      setCheckedDelivery(false);
      setCheckedBakong(false);
      
      if (typeof paymentMethod === "undefined" && checkedDelivery) {
        setPaymentMethod("cod");
        setCheckedDelivery(true);
      } 

      setWalletChecked((prev) => {
        const updatePrev = !prev;
        const currentTotalToPay = parseFloat(grossTotal).toFixed(2);

        if (updatePrev) {
          if (currentTotalToPay >= totalWalletAmount) {
            setTotalWalletAmount(0);
          } else {
            setTotalWalletAmount(props.wallet.amount - currentTotalToPay);
          }
        } else {
          setTotalWalletAmount(props.wallet.amount);
        }

        return updatePrev;
      });
    }
  };
  useEffect(() => {
    logPaymentInfo(items,'pay on delivery')
  },[])
  useEffect(() => {
    if (selectedSlot && props.user_address.length && paymentMethod !== "") {
      setEnableCheckOutButton(true);
    } else {
      setEnableCheckOutButton(false);
    }
  }, [selectedSlot, paymentMethod, props.user_address]);


  const totalHeight =
    headerState?.desktopHeight > 0 ? headerState.desktopHeight + 30 : 76 + 30;

  const generatetransactionid = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );

  useEffect(async () => {
    setTid(generatetransactionid);
    if (localStorage.getItem("expressMode")) {
      setCartType("express");
      setDeliveryColor("#f01266");
      props.initBasket("express");
    }
    setTimeout(() => {
      if (localStorage.getItem("expressMode")) {
        fetchOrderItems(isExpress);
      } else {
        fetchOrderItems();
      }
    }, 1000);

    let user = localStorage.getItem("user");
    let parsedUser = JSON.parse(user);
    if (parsedUser && localStorage.getItem("order_id") !== undefined) {
      let cust_id = parsedUser.cust_id;
      let order_id = localStorage.getItem("order_id");
      props.getAddress();
      props.allCouponCodes({
        order_id: order_id,
        cust_id: cust_id,
        string: "0",
      });
      let body = {};
      body["order_id"] = order_id;
      props.alldeliverySlots(body);
    } else {
      alert(t("shop_checkout_no_associated_order", false));
    }
  }, []);

  useEffect(() => {
    if (
      props.delivery_slots &&
      props.delivery_slots.length > 0 &&
      props.all_timings &&
      props.all_timings.length > 0
    ) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [props.delivery_slots, props.all_timings]);

  useEffect(() => {
    if (showPaymentModal === false) {
      setLoading(false);
    }
  }, [showPaymentModal]);

	// Scroll to top when supplierClose items are detected after slot selection
	useEffect(() => {
		if (shouldScrollToTop && supplierClose && supplierClose.length > 0) {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
			setShouldScrollToTop(false);
		}
	}, [supplierClose, shouldScrollToTop]);

	// useEffect(() => {
	//   if (props.all_slots !== undefined && props.all_slots[0] !== undefined && props.calendar_response.length > 0 && props.all_slots.length > 0) {
	//     setAllSlots(props.calendar_response);
	//     const newArr = [];
	//     const allSlots = props.all_slots;
	//     while (allSlots.length)
	//       newArr.push(allSlots.splice(0, props.delivery_slots.length));
	//     settwodslots(newArr);
	//   }
	// }, [props.delivery_slots]);
	const setDeliverySlots = (slot) => {
		setAllSlots(slot)
		settwodslots(slot)
	}
  const handleSelectAddressWhenCreateNew = (item) => {
    setChecked(1);
    setAddressIsInRange(item.isInRange);
    setIsInvalid({ isTrue: false, msg: "" });

    setSelectedAddress(item.address_id);
    let user = localStorage.getItem("user");
    let parsedUser = JSON.parse(user);
    let cust_id = parsedUser.cust_id;
    props.moveToCheckout({
      cust_id: cust_id,
      store_id: 1,
      order_id: localStorage.getItem("order_id"),
      address_id: item.address_id,
      type: cartType === "express" ? 1 : 0,
    });

    // Re-fetch slots + payment methods after address change.
    // PP vs province affects available delivery slots; address affects COD eligibility.
    // Delay ensures moveToCheckout has updated the order before re-fetching.
    setTimeout(() => {
      fetchPaymentMethods();
      props.alldeliverySlots({order_id: localStorage.getItem("order_id")});
    }, 500);
  }
  const selectDefaultAddress = () => {
    let defaultAddressID = selectedAddress;
    if (props.user_address.length) {
      defaultAddressID = props.user_address.find(item => item.is_default) || props?.user_address[0];

      // Note: COD visibility is controlled by payment gateway API
      // which checks both address AND product restrictions
      // Don't set hideCashOnDelivery here - let the API response handle it

      if (defaultAddressID) {
        return defaultAddressID.address_id;
      } else {
        return props?.user_address[0]?.address_id;
      }
    } else {
      return selectedAddress;
    }
  };

  useEffect(() => {
    if (selectedAddress !== 0 && props.user_address.length) {
      const findAddressSelected = props.user_address.find(
        (item) => item.address_id === selectedAddress
      );
      logShippingInfo(items,findAddressSelected)
      if (findAddressSelected.isInRange === false) {
        alert(t("shop_checkout_alert_selected_address_out_of_range"));
      }
      setAddressIsInRange(findAddressSelected.isInRange);
    }
  }, [props.user_address, selectedAddress]);

  // update payment method after updated address
  useEffect(() => {
    if(selectedAddressToUpdate && selectedAddress && selectedAddress === selectedAddressToUpdate.address_id){
      const updatedAddress = props.user_address.find(x => x.address_id === selectedAddressToUpdate.address_id);
      if(updatedAddress){
        // Re-fetch slots + payment methods for the updated address.
        // PP vs province affects available slots; location affects COD eligibility.
        // Delay ensures the [items, props.user_address, selectedAddress] effect's
        // moveToCheckout call has updated the order's address_id first.
        setTimeout(() => {
          fetchPaymentMethods();
          props.alldeliverySlots({order_id: localStorage.getItem("order_id")});
        }, 500);
      }
    }

    setSelectedAddressToUpdate(null);
  }, [props.user_address]);

  useEffect(() => {
    if (
      items.length > 0 &&
      props.user_address &&
      props.user_address.length > 0
    ) {
      setChecked(1);
      if (selectedAddress === 0) {
        setSelectedAddress(selectDefaultAddress());
      } else {
        let user = localStorage.getItem("user");
        let parsedUser = JSON.parse(user);
        let cust_id = parsedUser.cust_id;

        props.moveToCheckout({
          cust_id: cust_id,
          store_id: 1,
          order_id: localStorage.getItem("order_id"),
          address_id: selectedAddress,
          type: cartType === "express" ? 1 : 0,
        });
      }
    }
  }, [items, props.user_address, selectedAddress]);

  useEffect(() => {
    if (items.length > 0 && props.deliveryCharge !== undefined) {
      let amountTotal =
        parseFloat(carttotal ? carttotal : 0.0) -
        parseFloat(discount) +
        parseFloat(props.deliveryCharge);
      setGrossTotal(amountTotal);
    } else {
      let amountTotal =
        parseFloat(carttotal ? carttotal : 0.0) +
        parseFloat(props.deliveryCharge) -
        parseFloat(discount);
      setGrossTotal(0.0);
    }
  }, [items, props.deliveryCharge]);

  /**
   * Compute the final amount the customer must pay:
   * grossTotal → minus delipoints (if checked) → minus wallet (if checked)
   */
  const calcFinalTotal = () => {
    if (
      grossTotal === undefined ||
      grossTotal !== grossTotal || // NaN check
      localStorage.getItem("order_id") === undefined
    ) return 0.0;

    let total = grossTotal;

    // Priority 1: product promotion (per-item DeliPoints redemption)
    if (itemsRedeemChecked) {
      total = Math.max(total - itemsRedemptionAmount, 0);
    }

    // Priority 2: wallet
    if (walletChecked && props.wallet !== null) {
      total = Math.max(total - props.wallet.amount, 0);
    }

    // Priority 3: extra DeliPoints (order-level)
    if (delipointsChecked) {
      const itemPts = itemsRedeemChecked
        ? (items ?? []).reduce((sum, item) => sum + parseFloat(item.store_item_infos?.[0]?.dp_points ?? 0) * parseInt(item.dp_redeem_quantity ?? 0), 0)
        : 0;
      const remainingBalance = Math.max((dpBalance ?? 0) - itemPts, 0);
      const maxDeliValue = parseFloat((remainingBalance * parseFloat(dpSettings?.payment_value_per_point ?? 0)).toFixed(2));
      const extraDeliValue = Math.min(maxDeliValue, total);
      total = Math.max(total - extraDeliValue, 0);
    }

    return total;
  };

  const modifyTotal = () => {
    if (items.length > 0 && props.deliveryCharge !== undefined) {
      let amountTotal =
        parseFloat(carttotal ? carttotal : 0.0) -
        parseFloat(discount) +
        parseFloat(props.deliveryCharge);
      setGrossTotal(amountTotal);
    } else {
      let amountTotal =
        parseFloat(carttotal ? carttotal : 0.0) +
        parseFloat(props.deliveryCharge) -
        parseFloat(discount);
      setGrossTotal(0.0);
    }
  };

  const translateDay = (value) => {
    let day;
    if(lang === "en"){
      day = moment(value).format("dddd")
    }else{
      switch(parseInt(moment(value).format("d"))) {
        case 0:
          day = "ថ្ងៃអាទិត្យ"
          break;
        case 1:
          day = "ថ្ងៃច័ន្ទ"
          break;
        case 2:
          day = "ថ្ងៃអង្គារ"
          break;
        case 3:
          day = "ថ្ងៃពុធ"
          break;
        case 4:
          day = "ថ្ងៃព្រហស្បតិ៍"
          break;
        case 5:
          day = "ថ្ងៃសុក្រ"
          break;
        case 6:
          day = "ថ្ងៃសៅរ៍"
          break;
        default:
          day = "ថ្ងៃនេះ"
          break;
      }
    }
    return day;
  }

  const [ipDataUser, setIpDataUser] = React.useState({});
  const [waitingIpFetching, setWaitingIpFetching] = React.useState(false);
  const [showIpReginModal, setShowIpReginModal] = React.useState(false);
  let sendDataPayload = {};
  const ipModalSessions = sessionStorage.getItem("ipModalSessions")
  const handleShowIpReginModal = async () => {
    // Retrieve the stored modal session value
    const ipSessions = sessionStorage.getItem("ipModalSessions");

    // Check if the modal state is either null or explicitly "false"
    if (ipSessions == null || ipSessions == 1) {
      setShowIpReginModal(true);
      sessionStorage.setItem("ipModalSessions", 1);
    } else {
      await checkBasket(sendDataPayload);
    }
  };


  const handleCloseIpReginModal = async () => {
    sessionStorage.setItem("ipModalSessions", 0)
    setShowIpReginModal(false)
  };

  const getIP = async (type = 1) => {
    setWaitingIpFetching(true)
    await fetchIPData()
      .then(response => response.json())
      .then(async (data) => {
        if (data.success) {
          setIpDataUser(data);
          if (data && data.countryName) {
            handleShowIpReginModal();
          }
          if (data && data.countryName) {
            setWaitingIpFetching(false)
          }
        } else {
	        setLoading(true);
	        await handleSubmit({
		        preventDefault: () => {
		        }
	        }, true)
        }
      })
      .catch(async (error) => {
        console.log(error);
	      setLoading(true);
	      await handleSubmit({
		      preventDefault: () => {
		      }
	      })
      });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(isShopOpen === false && cartType !== "express"){
      let day, msg;
      const toDay = lang === "en" ? "today" : "ថ្ងៃនេះ";
      if(slotValidate !== null && slotValidate.slot_id){
        day = moment(slotValidate.date).isSame(moment(), "day") ? toDay : translateDay(slotValidate.date);
      }else{
        day = toDay;
      }
      if(lang === "en"){
        msg = `One or more items are not available for delivery ${day}`;
      }else{
        msg = `ទំនិញមួយ ឬច្រើនមិនមានសម្រាប់${day}`;
      }
      document.getElementById("slot").scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLoading(false);
      setIsInvalid({ isTrue: true, msg: msg});
    }else{
      if (cartItemsCount == 0 || carttotal == 0 || carttotal === NaN) {
        alert(t("shop_checkout_error_cart_is_empty", false));
        setLoading(false);
      } else if (carttotal < 10) {
	      Alert.warning(
          t("shop_checkout_alert_minimum_cart_amount_error_title", false) || "Minimum Order Amount",
          t("shop_checkout_alert_minimum_cart_amount_error", false, {
            path: "$10",
          }) || "Dear customer, minimum order amount is $10. Please review your cart to add more products."
        );
        setLoading(false);
      } else if (selectedSlot === 0 && cartType !== "express") {
        setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_delivery_schedule_selected_error", false) });
        document.getElementById("slot").scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        setLoading(false);
      } else if (props.user_address.length > 0) {
        if (!selectedAddress) {
          setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_address_selected_error", false) });
          document.getElementById("address").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setLoading(false);
        }
        if (!paymentMethod || paymentMethod === '') {
          setIsInvalid({ isTrue: true, msg: t("shop_checkout_forget_select_payment_error", false) });
          document.getElementById("payment").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setLoading(false);
        }
	      // if(hideCashOnDelivery && selfdelivery === 0){
	      //   setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_delivery_option_selected_error", false) });
	      //   document.getElementById("delivery-option").scrollIntoView({
	      //     behavior: "smooth",
	      //     block: "center",
	      //   });
	      //   setLoading(false);
	      //   return;
	      // }
        if(oosoption === ""){
          setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_oos_option_selected_error", false) });
          document.getElementById("oos-option").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setLoading(false);
          return;
        }
        if (selfdelivery === 1 && !selectedPickupPoint) {
          setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_pickup_point_selected_error", false) });
          document.getElementById("pickup-points-map").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setLoading(false);
          return;
        }
        if (localStorage.getItem("order_id") === undefined) {
          alert(t("shop_checkout_order_not_exist", false));
          setLoading(false);
        } else {
          let user = localStorage.getItem("user");
          let parsedUser = JSON.parse(user);
          let cust_id = parsedUser.cust_id;
          let slot = selectedSlot;
          if (selectedSlot === 0 && cartType !== "express") {
            setIsInvalid({ isTrue: true, msg: t("shop_checkout_alert_no_delivery_schedule_selected_error", false) });
            document.getElementById("slot").scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            setLoading(false);
            return;
          }
          setIsInvalid({ isTrue: false, msg: "" });
  
          let sendData = {};
          let order_details = {
            total_kms: props.distanceBetweenUserStore,
            address_id: selectedAddress,
            item_total: carttotal ? carttotal : 0.0,
	          slot: slotValidate,
            delivery_fees: props.deliveryCharge,
            comments: comment,
            coupon_discount: couponId != 0 ? parseFloat(discount) : 0,
            is_province: hideCashOnDelivery ,
          };
          if (walletChecked) {
            order_details.wallet_amount = props.wallet.amount;
          }
          const hasItemsRedeem = itemsRedeemChecked && itemsRedemptionAmount > 0;
          const itemsRedeemPoints = hasItemsRedeem
            ? (items ?? []).reduce((sum, item) => {
                const dpPoints = parseFloat(item.store_item_infos?.[0]?.dp_points ?? 0);
                return sum + dpPoints * parseInt(item.dp_redeem_quantity ?? 0);
              }, 0)
            : 0;

          if (delipointsChecked && dpRedemptionValue > 0 && hasItemsRedeem) {
            const dpResult = calcDelipointsResult();
            order_details.delipoints_amount = parseFloat((dpRedemptionValue + itemsRedemptionAmount).toFixed(2));
          } else if (delipointsChecked && dpRedemptionValue > 0) {
            const dpResult = calcDelipointsResult();
            order_details.delipoints_amount = parseFloat(dpRedemptionValue.toFixed(2));
          } else if (hasItemsRedeem) {
            order_details.delipoints_amount = parseFloat(itemsRedemptionAmount.toFixed(2));
          }
          sendData["order_details"] = order_details;
          sendData["store_id"] = 1;
          sendData["order_status"] = 2;
          sendData["order_id"] = localStorage.getItem("order_id");
          sendData["coupon_code_id"] = couponId != 0 ? couponId : null;
          sendData["p_method"] = paymentMethod !== "cod" ? "card" : paymentMethod;
          sendData["from"] = "website";
          sendData["oos_option"] = oosoption;
          sendData["self_deliver"] = selfdelivery === 1 ? 1 : 0;  // 1 = Pick up at bus station, 0 = Door to door delivery
          if (selfdelivery === 1 && selectedPickupPoint) {
            sendData["pickup_point_id"] = selectedPickupPoint.id;
          }
          sendData["type"] = cartType === "express" ? 1 : 0;
          sendData["is_apply_wallet"] = walletChecked;
          sendData["is_apply_delipoints"] = (delipointsChecked && dpRedemptionValue > 0) || hasItemsRedeem;
          sendData["is_apply_redeem_delipoints"] = hasItemsRedeem;
          sendData["is_apply_extra_delipoints"] = delipointsChecked && dpRedemptionValue > 0;
          sendDataPayload = sendData;
          if (addressIsInRange === false) {
            alert(t("shop_checkout_alert_selected_address_out_of_range"));
            setLoading(false);
          } else {
            if (selectedAddress !== 0) {
              // await initCheckout(sendData);
	            setLoading(true);
	            const data = await fetchIPData()
              .then(response => response.json())
              .catch(async (error) => {
                console.log(error);
	              setLoading(false);
	              return null;
              });
              if(paymentMethod !== "cod" && sendData && sendDataPayload && data && data.countryName && data.countryName != "Cambodia") {
                await getIP()
              }else{
                await checkBasket(sendData);
              }
            }
          }
        }
      } else {
	      setIsInvalid({isTrue: true, msg: t("shop_address_list_empty_message", false)});
	      document.getElementById("address").scrollIntoView({
		      behavior: "smooth",
		      block: "center",
	      });
        setLoading(false);
      }
      setLoading(false);
    }

  };


  const onCheckOutError = (checkoutResp) => {
    if (
      Array.isArray(checkoutResp.data.types) &&
      checkoutResp.data.types.length
    ) {
      setIsError(checkoutResp.data.types[0]);
      const pattern = [
        "deliveryFeeChanged",
        "invalidCoupon",
        "slotNotAvailable",
        "expressSlotFull",
        "itemChanged",
        "itemRemoved",
        "noItemAvailable",
        "outOfRange",
        "walletAmountChanged",
        "orderAlreadyPaid",
        "noOrderExist",
        "invalidProvincePaymentMethod",
      ];

      setDialogHeaderLabel(t("shop_checkout_alert_error"));
      if (pattern.includes(checkoutResp.data.types[0])) {
        setErrorMessage(
          reactStringReplace(checkoutResp.message, /(\n)/g, () => <br />)
        );
        setShowPaymentModal(false);
        setShowError(true);

        // On item price change and out of stock
        // Just re-load the basket
        if (
          ["itemChanged", "itemRemoved"].includes(checkoutResp.data.types[0])
        ) {
          fetchOrderItems(cartType);
        }
        // All items in basket are out of stock or has been disabled/deleted by admin
        // so we have to move current order to cancel
        else if (checkoutResp.data.types[0] === "noItemAvailable") {
          clearCart();
          setTimeout(() => {
            history.push("/all-orders");
          }, 4000);
        }
      }
    } else {
      setDialogHeaderLabel(t("shop_checkout_alert_error"));
      setErrorMessage(t("shop_item_update_error"));
      setShowPaymentModal(false);
      setShowError(true);
    }
  };

  const checkBasket = async (sendData) => {
	  setLoading(true);
	  let query = localStorage.getItem('expressMode') ? 1 : 0;
    const response = await RED_API.CheckBasket(query);
    const data = await response.json();
    if (data.isLocked) {
      if (!window.confirm(t("shop_checkout_error_payment_in_progress"))) return;
      const orderLockResp = await expressService.orderLocked(cartType);
      if(orderLockResp.status === 200) {
        await initCheckout(sendData);
      } else {
        alert("error");
      }
    } else {
      await initCheckout(sendData);
    }
  };

  const initCheckout = async (sendData) => {
    setLoading(true)
	  if (paymentMethod === "cod" && selectedPaymentType !== "ABA_PAY") {
      const checkoutResp = await checkoutService.doCheckout(sendData, cartType);

      if (checkoutResp.data.success) {
        setLoading(false)
        setModalShow(true);
        logPurchase(items,props.checkoutdata)
        clearCart();
        localStorage.setItem("order_id", 0);
        setTimeout(() => {
          setLoading(false);
          history.push("/all-orders");
        }, 4000);
      } else {
        onCheckOutError(checkoutResp);
      }
	  } else if (selectedPaymentType === "ABA_PAY") {
		  const checkoutResp = await checkoutService.doCheckout(sendData, cartType);
		  if (checkoutResp.data.success) {
			  setShowPaymentModal(true)
			  props.expressCheckout({
				  data: {},
				  success: true,
			  });
		  } else {
			  onCheckOutError(checkoutResp);
		  }
	  } else if (["card", "abapay", "bakong"].includes(paymentMethod)) {
      const checkoutResp = await checkoutService.doCheckout(sendData, cartType);
      if (checkoutResp.data.success) {
        handlePayemntShow();
        props.expressCheckout({
          data: {},
          success: true,
        });
      } else {
        onCheckOutError(checkoutResp);
      }
    }
    else if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].includes(paymentMethod)) {
      if (kessPayment[paymentMethod] === "VISA_MASTER") {
        if (historyCard.length < 1) {
          await RED_API.GetVisaToken()
            .then(res => res.json())
            .then(async (res) => {
              if (res.success) {
                if (res.data.length > 0) {
                  setShowDialog(true);
                  setHistoryCard(res.data);
                  setLoading(false);
                  if(res.data[selectedIndex]?.is_expired === 0){
                    setCardToken(res.data[selectedIndex].card_token);
                    setIsOldCardExpired(false)
                  } else {
                    setCardToken("");
                    setIsOldCardExpired(true)
                  }
                } else {
                  const checkoutResp = await checkoutService.doCheckout(sendData, cartType);
                  if (checkoutResp.data.success) {
	                  setLoading(true)
                    paymentCreateOrder();
                    props.expressCheckout({
                      data: {},
                      success: true,
                    });
                  } else {
                    onCheckOutError(checkoutResp);
	                  setLoading(false)
                  }
                }
              }
            }).catch(error => console.error(error));
        } else {
          const checkoutResp = await checkoutService.doCheckout(sendData, cartType);
          if (checkoutResp.data.success) {
            if (isNewCard) {
              paymentCreateOrder();
            } else {
              paymentWithOldCard();
            }
            props.expressCheckout({
              data: {},
              success: true,
            });
          } else {
            onCheckOutError(checkoutResp);
          }
        }
      } else {
        const checkoutResp = await checkoutService.doCheckout(sendData, cartType);
        if (checkoutResp.data.success) {
	        setLoading(true)
	        paymentCreateOrder();
          props.expressCheckout({
            data: {},
            success: true,
          });
        } else {
          onCheckOutError(checkoutResp);
	        setLoading(false)
        }
    }
    }
    setLoading(false)
  };


  const handlePaymentWithNewCard = (e) => {
    e.stopPropagation();
    isNewCard = true;
    handleSubmit(e);
  };

  const handlePaymentWidthOldCard = (e) => {
    e.stopPropagation();
    isNewCard = false;
    handleSubmit(e)
  };

  const handleHideShowCheckOutDialog = (status) => {
    clearInterval(checkPaymentIntervalId); // It's to avoid duplicate invoice.
	  setCheckPaymentIntervalId(null);
    setLoading(false);
    setShowPaymentModal(false);
    setPaymentMethod("");
    setEnableCheckOutButton(false);

    props.changeOrderStatus();
  };

  useEffect(() => {
    if (props.orderPlaced === true && paymentMethod === "cod") {
      setModalShow(true);
      clearCart();
      localStorage.setItem("order_id", 0);
      setTimeout(() => {
        setLoading(false);
        history.push("/all-orders");
      }, 4000);
    } else if (
      props.orderPlaced === true &&
      (paymentMethod === "card" ||
        paymentMethod === "abapay" ||
	      paymentMethod === "bakong") ||
	    selectedPaymentType === "ABA_PAY"
    ) {
      if (
        localStorage.getItem("order_id") &&
        (localStorage.getItem("order_id") !== 0 ||
          localStorage.getItem("order_id") !== "0")
      ) {
	      //add script for mobile check redirect page when orders status success
	      if (out_trade_no && window?.webkit && window.webkit?.messageHandlers && window.webkit?.messageHandlers?.onPaymentSuccess) {
		      window.webkit.messageHandlers.onPaymentSuccess.postMessage({
			      status: "success",
			      transactionId: out_trade_no
		      });
	      }
        handlePayemntShow();
        handlePaySubmit();
      } else {
        alert(t("login_re_login_error", false));
      }
    }
  }, [props.orderPlaced]);

  // ---- Payment checker -----
  const handlePaySubmit = async (e) => {
    let token = localStorage.getItem("token");

    if (token) {
	    // Clear any existing interval before creating a new one
	    if (checkPaymentIntervalId) {
		    clearInterval(checkPaymentIntervalId);
	    }

      function getAlerts() {
        const type = cartType === "express" ? 1 : 0;
        const data = { order_id: localStorage.getItem("order_id") };
        const header = { headers: { Authorization: token } };
        axios
          .post(
            constant.baseUrl + "v1/web/basket/verify/aba?type=" + type,
            data,
            header
          )
          .then(function (response) {
            if (response.data.success && response.data.data.is_paid) {
              checkPaymentDate();
              logPurchase(items,props.checkoutdata)
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      const intervalId = setInterval(() => getAlerts(), 5000);
      setCheckPaymentIntervalId(intervalId);
    } else {
      alert("Please sign in");
    }
  };
  const checkPaymentDate = async (e) => {
	  // Clear the payment check interval since payment is successful
	  if (checkPaymentIntervalId) {
		  clearInterval(checkPaymentIntervalId);
		  setCheckPaymentIntervalId(null);
	  }
    setModalShow(true);
    handlePaymentClose();
    clearCart();
    localStorage.setItem("order_id", 0);
    setTimeout(() => {
      setLoading(false);
      history.push("/all-orders");
    }, 4000);
  };

	// Cleanup interval on component unmount
	useEffect(() => {
		return () => {
			if (checkPaymentIntervalId) {
				clearInterval(checkPaymentIntervalId);
			}
		};
	}, [checkPaymentIntervalId]);
  // ---- Payment checker -----

  // Add or edit modal
  const [addressModal, setAddressModal] = useState(false)
  const [addressModalType, setAddressModalType] = useState("add")
  const handleModal = (component,item,type) => {
    setAddressModalType(type)
    setAddressModal(!addressModal)
  };


  const handleEditDelete = async (item, type, name) => {
    if (type === "edit") {
      setSelectedAddressToUpdate(item);
      const modalComponent = name === "address" ? UpdateAddress : UpdateContact;
      handleModal(modalComponent, item, "edit");
    } else if (type === "delete") {
      if (item.is_default) {
        alert(t("shop_checkout_cant_delete_default_address_error", false));
      } else {
        let response = window.confirm(
          t("shop_checkout_confirm_delete_address", false)
        );
        if (response === true) {
          props.deleteAddress({ address_id: item.address_id });
          window.location.reload();
        }
      }
    } else {
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: anim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const restrictedrange = (start, end) => {
    return Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);
  };
	const formatSchedule = () => {
		// --- Input Validation ---
		if (!slotValidate || typeof slotValidate !== 'object') {
			console.error("Error: 'slot' argument is missing or not an object. Cannot format schedule.");
			return "Error: Invalid slot data provided.";
		}

		if (!slotValidate) {
			console.error("Error: 'slot.date' property is missing from the provided slot object.");
			return "Error: Slot date unavailable.";
		}

		if (!slotValidate.start_time) {
			console.error("Error: 'slot.start_time' property is missing from the provided slot object.");
			return "Error: Slot start time unavailable.";
		}

		const slotDate = new Date(slotValidate.start_time);

		// Validate if the Date object was successfully created (i.e., the date string was valid).
		if (isNaN(slotDate.getTime())) {
			console.error(`Error: Invalid date string '${slotValidate.start_time}' in the provided slot object.`);
			return "Error: Invalid slot date.";
    }

		const formattedDate = slotDate.toLocaleDateString("en-US", {
			weekday: "short", // e.g., "Tue"
			month: "short",   // e.g., "May"
			day: "2-digit",   // e.g., "27"
		});

		const startFormattedTime = formattimeheader(slotValidate.start_time);
		const endFormattedTime = formattimeheader(slotValidate.end_time);

		// --- Return the combined formatted string ---
		return `${formattedDate} , ${startFormattedTime}- ${endFormattedTime}`;
  };

	function formattimeheader(timeString) {
		// This example converts a string like "2025-05-27 10:00" to "10:00 AM"
		const dateObj = new Date(timeString);
		if (isNaN(dateObj.getTime())) {
			console.error(`Error: Invalid time string passed to formattimeheader: ${timeString}`);
			return "Invalid Time";
		}
		return dateObj.toLocaleTimeString("en-US", {
			hour: "2-digit",
			hour12: true, // Use 12-hour format with AM/PM
    });
	}

  const handleDeliverySlotCloseModal = (status = false) =>
    setShowSchedule(status);
  const onSlotSelected = async(slot_id, data) => {
    setSlotValidate(data);
    setLoading(true)
    let cartType = "normal";
    await fetchOrderItems(cartType, data);
	  setSelectedSlot(data.slot_id);

    setTimeout(() => {
      setShowSchedule(prev => !prev);

	    // Set flag to trigger scroll check in useEffect
	    setShouldScrollToTop(true);
    }, 350);
    setLoading(false);
  };

  const handleErrorModalClose = () => {
    setShowError(false);
    setLoading(false);

    if (isError === "noItemAvailable") {
      clearCart();
      localStorage.setItem("order_id", 0);
      history.push("/express");
    }

    window.location.reload();
  };

  const handleRemoveCoupon = (e) => {
    if(e){
      e.preventDefault();
    }
    setSelectedAddress(selectDefaultAddress()); //when remove coupon to reset address
    setPaymentMethod('cod');
    setCheckedDelivery(true);
    setIsPayOnline(false);

    removeCoupon();
    setSelectedCode("");
    setCouponCode("");
    setDefaultCoupon("");
    setCouponId(0);
    setDiscount(0);
    setHasCoupon(false);
    let amountTotal =
      parseFloat(carttotal ? carttotal : 0.0) +
      parseFloat(props.deliveryCharge);
    if (walletChecked) {
      if (amountTotal >= props.wallet.amount) {
        setTotalWalletAmount(0);
      } else {
        setTotalWalletAmount(props.wallet.amount - amountTotal);
      }
    } else {
      setTotalWalletAmount(props.wallet.amount);
    }
    setGrossTotal(amountTotal);
    props.moveToCheckout({
      cust_id: props.user_address[0].cust_id,
      store_id: 1,
      order_id: localStorage.getItem("order_id"),
      address_id: props.user_address[0].address_id,
      type: cartType === "express" ? 1 : 0,
    });
  };

  const handleCouponSelected = (coupon) => {
    if (coupon.is_valid != 0 && coupon.applicable != "no") {
      setSelectedCode(coupon.code);
      setCouponId(coupon.id);
      setHasCoupon(true);
      setDiscount(coupon.discountPrice);
      setCouponCode(coupon.code);

      let amountTotal =
        parseFloat(carttotal ? carttotal : 0.0) +
        parseFloat(props.deliveryCharge) -
        parseFloat(coupon.discountPrice);

      if (walletChecked) {
        if (amountTotal >= props.wallet.amount) {
          setTotalWalletAmount(0);
        } else {
          setTotalWalletAmount(props.wallet.amount - amountTotal);
        }
      } else {
        setTotalWalletAmount(props.wallet.amount);
      }

      setGrossTotal(amountTotal);
      setShow(false);
    } else {
      alert(t("shop_checkout_error_coupon_code", false));
    }
  };

  const calcWalletAmount = () => {
    let result = 0.0;
    const afterDelipoints = Math.max(
      grossTotal
        - (itemsRedeemChecked ? itemsRedemptionAmount : 0)
        - (delipointsChecked ? dpRedemptionValue : 0),
      0
    );
    if (afterDelipoints - props.wallet.amount > 0) {
      result = afterDelipoints - props.wallet.amount;
    }
    return result;
  };

  // Coupon
  const [couponCode, setCouponCode] = useState("");
  const [isSearchingCoupong, setIsSearchingCoupon] = useState(false);
  const [
    isShowModalConfirmNoFoundCouponCode,
    setIsShowModalConfirmNoFoundCouponCode,
  ] = useState(false);
  const [message, setMesssage] = useState("")
  const [couponList, setCouponList] = useState([]);
  const [isShowModalErrorMinBacketAmount, setIsShowModalErrorMinBacketAmount] = useState(false);
  const [minBacketAmountSelectedCoupon, setMinBacketAmountSelectedCoupon] = useState(0);
  const [errorMinBasketAmountMessage, setErrorMinBasketAmountMessage] = useState("");

  useEffect(() => {
    if(selectedCode){
      if(parseFloat(carttotal) < parseFloat(minBacketAmountSelectedCoupon)){
        handleShowErrorMinBasketAmount(minBacketAmountSelectedCoupon)
      }else{
        // re-call api search coupon code to recalculate discount value
        // in case discount percentage after subtotal change discount value need to be uptodate
        handleSearchCouponCode(selectedCode.trim())
      }
    }
  }, [carttotal])

  const handleSearchCouponCode = (search) => {
    setIsSearchingCoupon(true);
      if (localStorage.getItem("order_id") !== undefined) {
        let body = {
          order_id: localStorage.getItem("order_id"),
          cust_id: 1,
          string: search,
          address_id: selectedAddress
        };
        RED_API.GetAllCouponCodes(body)
          .then((res) => {
            if (checkAuthError(res)) {
              //logout
              throw new Error("Unauthorized");
            } else {
              return res.json();
            }
          })
          .then((data) => {
            if (data.success) {
              
              if (body["search"] != "") {
                data.data.sort((a, b) => {
                  if (
                    a.code.indexOf(body["search"]) >
                    b.code.indexOf(body["search"])
                  ) {
                    return 1;
                  } else if (
                    a.code.indexOf(body["search"]) <
                    b.code.indexOf(body["search"])
                  ) {
                    return -1;
                  } else {
                    if (a.code > b.code) return 1;
                    else return -1;
                  }
                });
              }
  
              if (body["search"] != "") {
                data.data.sort((a, b) => {
                  return (
                    a.code.indexOf(body["search"]) -
                    b.name.indexOf(body["search"])
                  );
                });
              }
  
              let foundCoupon = data.data.find((x) => x.code === search);
              const addrSelect = props.user_address.find((item) => item.address_id === selectedAddress)
              if(foundCoupon.percentage === 0 && foundCoupon.fixed === 0 && addrSelect && addrSelect.city === "Province"){
                setMesssage(t("cannot_apply_coupon_for_province"));
                setIsSearchingCoupon(false);
                setIsShowModalConfirmNoFoundCouponCode(true);
              }else{
                if (foundCoupon) {
                  setMinBacketAmountSelectedCoupon(foundCoupon.min_cart_value);
                  if(parseFloat(carttotal) >= parseFloat(foundCoupon.min_cart_value)){
                    handleCouponSelected(foundCoupon);
                    setPaymentMethod('cod');
                    setCheckedDelivery(true);
                    setIsPayOnline(false);
                  }else{
                    handleShowErrorMinBasketAmount(foundCoupon.min_cart_value)
                  }
    
                  if(data.data[0].free_delivery) {
                    props.moveToCheckout({
                      cust_id: data.data[0].cust_id,
                      store_id: 1,
                      order_id: data.data[0].order_id,
                      free_delivery_bucket_value: data.data[0].free_delivery_bucket_value,
                      address_id: data.data[0].address_id,
                      type: cartType === "express" ? 1 : 0,
                      free_delivery: data.data[0].free_delivery
                    });
                  } 
                } else {
                  setMesssage("Invalid Coupon");
                  setIsShowModalConfirmNoFoundCouponCode(true);
                }
              }
              setIsSearchingCoupon(false);
            } else {
              if(data.data) {
                let item_name = '';
                if(data.data.item_name) {
                  data.data.item_name.forEach((item, index) => {
                    item_name+=item + ', ';
                  });
                  item_name = item_name.replace(/,\s*$/, "");
                }
                if(data.data.fix_price > 0) {
                  let msg = `Your Item Price (${item_name}) should be greater than $${data.data.fix_price}`
                  setMesssage(msg);
                } else if(data.data.min_cart_value > 0) {
                  let msg = `Your Item Price (${item_name}) should be greater than $${data.data.min_cart_value}`;
                  setMesssage(msg);
                } else {
                  setMesssage(data.msg);
                }
              } else {
                setMesssage(data.msg);
              }
              setIsSearchingCoupon(false);
              setIsShowModalConfirmNoFoundCouponCode(true);
            }
          })
          .catch((err) => {
            if (err.message === "Unauthorized") {
              alert("Your login session is invalid, please login again");
              logoutuser();
            }
            setIsSearchingCoupon(false);
          });
        props.allCouponCodes({
          order_id: localStorage.getItem("order_id"),
          cust_id: 1,
          string: search,
          address_id: selectedAddress
        });
      }
    // setCouponCode(couponCode);
  };

  const handleShowErrorMinBasketAmount = (minCartValue) => {
    setErrorMinBasketAmountMessage(t("shop_checkout_error_minimum_basket_coupon", true, {
      path: `$ ${minCartValue}`,
    }));
    setIsShowModalErrorMinBacketAmount(true);
  }

  const handleCloseModalConfirmErrorMinBacketAmount = () => {
    setErrorMinBasketAmountMessage("");
    setMinBacketAmountSelectedCoupon(0);
    setIsShowModalErrorMinBacketAmount(false);
    handleRemoveCoupon();
  }

  useEffect(() => {
    if (parseFloat(calcFinalTotal()) === 0) {
      setIsDisabled(true);
      paymentOptionChoose('cod');
      setCheckedDelivery(false);
      setIsPayOnline(false)
    } else {
      setIsDisabled(false);
      if(!hideCashOnDelivery){
        paymentOptionChoose('cod');
        setCheckedDelivery(true);    
        setIsPayOnline(false)    
      }
    }

  }, [grossTotal, walletChecked, delipointsChecked, dpRedemptionValue]);

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if(updateOrder){
      setUpdateOrder(false)
      handleRemoveCoupon()
    }

  },[updateOrder]);

  useEffect(() => {
    if(!walletChecked){ //not select wallet
      if(!hideCashOnDelivery){
        paymentOptionChoose("cod")
        setIsPayOnline(false)
      }else{
        setCheckedDelivery(false);
        setIsPayOnline(true)
        paymentOptionChoose('0');
      }      
    }else{//select wallet
      if(calcWalletAmount() === 0){
        paymentOptionChoose("cod")
        setIsPayOnline(false)
        setCheckedDelivery(false);
      }else if(hideCashOnDelivery){
        setCheckedDelivery(false);
        setIsPayOnline(true)
        paymentOptionChoose('0');
      }
    }
  },[hideCashOnDelivery, grossTotal, walletChecked])
  
  const deliveryOptions = [
    { title: "shop_checkout_pick_up_at_bus_station_option", value: 1 },
    { title: "shop_checkout_door_to_door_option", value: 2 },
  ];
  const oosOptions = [
    {
      title: "shop_checkout_cancel_item_option_title",
      description: "shop_checkout_cancel_item_option_desc",
      value: "Cancel Item",
    },
    {
      title: "shop_checkout_be_contacted_option_title",
      description: "shop_checkout_be_contacted_option_desc",
      value: "Be Contacted",
    },
  ];

  const handleChooseDeliveryOption = (e) => {
    let { value } = e.target;
    setSelfDelivery(parseInt(value))
    if (parseInt(value) === 2) {
      setSelectedPickupPoint(null);
    }
  }
  const handleSelectPickupPoint = (point) => {
    setSelectedPickupPoint(point);
  }
  const handleChooseOosOption = (e) => {
    let { value } = e.target;
    setOOSOption(value)
  }

  const handleOpenNormalHour = (item, open) => {
    const itemToday = item?.find((val) => val.is_open === true && val.is_today === true);
    setItemForToday(itemToday);
    setOpenModalHours(!open);
    setNormalOpenHours(item);
  }

  const handleCloseNormalHour = (open) => {
    setOpenModalHours(!open);
  }


  // verify and check payment when nodify from KESS
    const orderData = localStorage.getItem('order_data')
    const [showErrorModal, setShowErrorModal] = useState(false)
    const searchParams = new URLSearchParams(window.location.search);
    const out_trade_no = searchParams.get("out_trade_no");
    const success_status = searchParams.get("success");
    const message_status = searchParams.get("message");
    const pay_response_acquirerMessage = searchParams.get("pay_response[acquirerMessage]");
    const pay_response_gatewayCode = searchParams.get("pay_response[gatewayCode]");
    const handleToggleShowErrorModal = () => {
      setShowErrorModal(!showErrorModal)
      history.replace("/checkout", null, null);
    }

    const checkFailerBedgetwayCode = (code) => {
      switch(code) {
        case "WAITING_FINAL_STATUS" :
          return {label:"PAYMENT_PENDING",color:"#9cc54b", icon: HourglassEmptyIcon};
        case "SUCCESS" :
          return {label:"SUCCESS", color:"#9cc54b", icon: CheckCircleOutlineIcon};
        default :
          return {label:"PAYMENT_FAIL_TITLE", color: "#9cc54b", icon: ErrorOutlineIcon}
      }
    }
    //check and verify payment
  useEffect(async () => {
    try {
      if (window.location.search !== "" && out_trade_no && success_status == 0) {
        return setShowErrorModal(true)
      }
      if (window.location.search !== "" && out_trade_no && success_status != 0) {
        await RED_API.GetNewVisaToken()
          .then(res => res.json())
          .then((res) => {
            if (res.success) {
              if (res.data.is_new == 1) {
                sessionStorage.setItem("is_new_visa_card", 1);
              }
              setModalShow(true);
              if (orderData) {
                logPurchaseOnOnlinePayment(orderData)
              }
              let reload = setTimeout(() => {
                setModalShow(false);
                window.location.href = "/all-orders";
                localStorage.removeItem('order_data')
              }, 3000);

              return () => clearTimeout(reload);
            }
          });
      }
    } catch (error) {
      alert(error.message)
    }
  }, []);

  const [couponFetching, setCouponFetching] = useState(false);
  const [defaultCoupon, setDefaultCoupon] = useState("");
  const [listCoupon, setListCoupon] = useState([]);
  const [showAll, setShowAll] = useState(false);
  // const [couponCode, setCouponCode] = useState("");

// Ensure listCoupon is not empty before accessing firstCoupon
  const [firstCoupon, setFirstCoupon] = useState(null);
  const [remainingCoupons, setRemainingCoupons] = useState([]);
// Parse user data once and store it in state
  let user = localStorage.getItem("user");
  let parsedUser = JSON.parse(user);

  const hanldeChangeCoupon = (e) => {
    setCouponCode("")
    if(e) {
      setDefaultCoupon(e.target.value);
      if(e.target.value !== "input_code"){
        setCouponCode(e.target.value)
      }else{
        setCouponCode("")
      }
    }
  };

// Keep couponCode empty if input_code is selected
  useEffect(() => {
    if (defaultCoupon === "input_code") {
      setCouponCode("");
    }
  }, [defaultCoupon]);
  const getCouponList = async () => {
    setCouponFetching(true);
    try {
      const response = await RED_API.getCouponCanApply({
        user_id: parsedUser?.cust_id,
        order_id: localStorage.getItem("order_id") || 0,
      });
      const res = await response.json();

      if (res.success) {
        setListCoupon(res.data?.coupons || []);
        setFirstCoupon(res.data?.coupons?.[0] || null);
      } else {
        setListCoupon([]);
        setFirstCoupon(null);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      setListCoupon([]);
      setFirstCoupon(null);
    } finally {
      setCouponFetching(false);
    }
  };
  // Fetch coupon list on component mount
  useEffect(() => {
    getCouponList();
  }, []);

// Update remainingCoupons when listCoupon or firstCoupon changes
  useEffect(() => {
    if (listCoupon.length > 0 && firstCoupon?.can_apply) {
      setRemainingCoupons(listCoupon.filter(coupon => coupon?._id !== firstCoupon?._id));
    } else if(listCoupon.length > 0 && !firstCoupon?.can_apply){
        setRemainingCoupons(listCoupon);
    } else {
      // setFirstCoupon(null);
      setRemainingCoupons([]);
    }
  }, [listCoupon, firstCoupon]);

  return (
    <form>
      <CheckoutWrapper>
      <Title>{t("shop_checkout_your_order_label")}</Title>
        <CheckoutContainer>
          <CartWrapper>
            <Sticky enabled={false} top={totalHeight} innerZ={999}>
              <OrderInfo>
                <OrderBox
                  style={{
                    padding: "30px 10px 20px 10px"
                  }}
                >
                  <ScrollBarsWrapper>
                  <Scrollbars
                    universal
                    autoHide
                    autoHeight
                    autoHeightMax="auto"
                    renderView={(props) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          marginLeft: props.style.marginRight,
                          marginRight: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }}
                      />
                    )}
                  >
                    <ItemsWrapper className="items-wrapper-supplier">
                      {/* {carttotal > 0 && items && (
                        <NoProductMsg>
                          <span style={{ fontWeight: "700", color: "black" }}>
                            {t("shop_checkout_products_not_available")}
                          </span>
                        </NoProductMsg>
                      )} */}
                      {cartType !== "express" && supplierClose.length > 0 && 
                        <div
                          style={{
                            border: "2px solid red",
                            padding: 10,
                            backgroundColor: '#dc35450f',
                            marginBottom: 15
                          }}
                        >
                          {supplierClose.map((item, idex) => (
                            <div
                              key={idex}
                              style={{
                                marginBottom: idex+1 === supplierClose.length ? 0 : 25
                              }}
                            >
                              <p 
                                className={`title d-flex align-items-center justify-content-between mb-3`}
                              >
                                <span>
                                  <div className="d-flex align-items-center">
                                    <span className="mr-2"><IconStore color="#9cc54b" width="35px" height="35px"/></span>
                                    <span
                                      style={{
                                        fontSize: 18,
                                        fontWeight: "bold",
                                        lineHeight: 1.2
                                      }}
                                    >
                                      {/* {`${item.first_name} ${item.last_name}`} */}
                                      {/* {t("shop_title")}&ensp; */}
                                      <TitleRemark 
                                        className='text-danger'
                                        style={{
                                          fontSize: 14
                                        }}
                                      >
                                        {remark}
                                      </TitleRemark>
                                      <TitleRemark 
                                        className='text-danger'
                                        style={{
                                          fontSize: 14
                                        }}
                                      >
                                        {remark_body}
                                      </TitleRemark>
                                    </span>
                                  </div>
                                </span>
                                <DivTitleBusinessHours 
                                  className="px-2 py-1 border rounded-lg" 
                                  style={{
                                    borderColor: "#9cc54b", 
                                    color: "#9cc54b", 
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => handleOpenNormalHour(item.normal_open_hours, openModalHours)}
                                >
                                  <span className="mr-2 m-0-mobile"><IconAlarm color="#9cc54b" width="20px" height="20px"/></span>
                                  <TitleBusinessHours>{t("businessHours")}</TitleBusinessHours>
                                </DivTitleBusinessHours>
                              </p>
                              {item.store_item_info.length > 0 && (
                                item.store_item_info.map((val) => (
                                  <ItemSupplierClose
                                    key={`cartItem-${val.item_id}`}
                                    product={val}
                                    props={props}
                                    address_id={selectedAddress}
                                    modify_total={modifyTotal}
                                    cartType={cartType}
                                    setWalletChecked={setWalletChecked}
                                    walletChecked={walletChecked}
                                    setTotalWalletAmount={setTotalWalletAmount}
                                    setPaymentMethod={setPaymentMethod}
                                    setUpdateOrder={setUpdateOrder}
                                    setRemoveProduct={setRemoveProduct}
                                    //open hours for normal
                                    slotValidate={slotValidate}
                                  />
                                ))
                              )}
                            </div>
                          ))}
                        </div>
                      }
                      {carttotal > 0 && items ? (
                        items.map((item) => (
                          cartType !== "express" && item.store_item_infos[0].is_shop_normal_open === true ?
                            <OrderItem
                              key={`cartItem-${item.item_id}`}
                              product={item}
                              props={props}
                              address_id={selectedAddress}
                              modify_total={modifyTotal}
                              cartType={cartType}
                              setWalletChecked={setWalletChecked}
                              setDelipointsChecked={setDelipointsChecked}
                              walletChecked={walletChecked}
                              setTotalWalletAmount={setTotalWalletAmount}
                              setPaymentMethod={setPaymentMethod}
                              setUpdateOrder={setUpdateOrder}
                              setRemoveProduct={setRemoveProduct}
                              slotValidate={slotValidate}
                              itemsRedeemChecked={itemsRedeemChecked}
                            />
                          : cartType === "express" ?
                            <OrderItem
                              key={`cartItem-${item.item_id}`}
                              product={item}
                              props={props}
                              address_id={selectedAddress}
                              modify_total={modifyTotal}
                              cartType={cartType}
                              setWalletChecked={setWalletChecked}
                              setDelipointsChecked={setDelipointsChecked}
                              walletChecked={walletChecked}
                              setTotalWalletAmount={setTotalWalletAmount}
                              setPaymentMethod={setPaymentMethod}
                              setUpdateOrder={setUpdateOrder}
                              setRemoveProduct={setRemoveProduct}
                              slotValidate={slotValidate}
                              itemsRedeemChecked={itemsRedeemChecked}
                            />
                          :null
                        ))
                      ) : (
                        <NoProductMsg>
                          <span>
                            {reactStringReplace(
                              `${t("shop_checkout_error_cart_empty", false)}`,
                              /({path})/g,
                              (item, index) => (
                                <span
                                  key={`err-${index}`}
                                  onClick={() => {
                                    history.push("/");
                                  }}
                                  style={{
                                    textDecoration: "none",
                                    color: "unset",
                                    cursor: "pointer",
                                  }}
                                >
                                  {t("shop_checkout_browse_our_shop_redirection")}
                                </span>
                              )
                            )}
                          </span>
                        </NoProductMsg>
                      )}
                    </ItemsWrapper>
                  </Scrollbars>
                  </ScrollBarsWrapper>
                </OrderBox>
                <CalculationWrapper>
                  <div className="sub-container">
                    <TextWrapper>
                      <Text>{t("shop_checkout_subtotal")}</Text>
                      <Text>
                        {CURRENCY}
                        {parseFloat(carttotal && items ? carttotal : 0.0).toFixed(
                          2
                        )}
                      </Text>
                    </TextWrapper>

                    <TextWrapper>
                      <Text>{t("shop_checkout_delivery")}</Text>
                      <Text>
                        {CURRENCY}
                        {props.deliveryCharge
                          ? parseFloat(props.deliveryCharge).toFixed(2)
                          : parseFloat(0.0).toFixed(2)}
                      </Text>
                    </TextWrapper>

                    <TextWrapper>
                      <Text>{t("shop_checkout_discount")}</Text>
                      <Text>
                        {CURRENCY}
                        {parseFloat(discount).toFixed(2)}
                      </Text>
                    </TextWrapper>

                    {/* ── Order value (fixed — never changes) ── */}
                    <TextWrapper style={{ borderTop: "1px solid #e8e8e8", paddingTop: 12, marginTop: 8 }}>
                      <Bold><Text>{t("shop_checkout_order_value")}</Text></Bold>
                      <Bold>
                        <Text>
                          {CURRENCY}
                          {parseFloat(grossTotal).toFixed(2)}
                        </Text>
                      </Bold>
                    </TextWrapper>

                    {/* ── Priority 1: Per-item DeliPoints redeem (product promotion) ── */}
                    {itemsRedeemChecked && itemsRedemptionAmount > 0 && (
                      <TextWrapper style={{ opacity: 0.85 }}>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          {t("shop_checkout_delipoints_product_paid")}
                        </Text>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          -{CURRENCY}
                          {itemsRedemptionAmount.toFixed(2)}
                        </Text>
                      </TextWrapper>
                    )}

                    {/* ── Priority 2: Wallet paid ── */}
                    {walletChecked && props.wallet !== null && props.wallet.amount > 0 && (
                      <TextWrapper>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          {t("shop_checkout_wallet_paid")}
                        </Text>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          -{CURRENCY}
                          {(() => {
                            const afterPromo = Math.max(grossTotal - (itemsRedeemChecked ? itemsRedemptionAmount : 0), 0);
                            return parseFloat(Math.min(props.wallet.amount, afterPromo)).toFixed(2);
                          })()}
                        </Text>
                      </TextWrapper>
                    )}

                    {/* ── Priority 3: Extra DeliPoints paid (order-level) ── */}
                    {delipointsChecked && dpRedemptionValue > 0 && (
                      <TextWrapper>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          {t("shop_checkout_delipoints_paid")}
                        </Text>
                        <Text style={{ color: "#5a9e2f", fontSize: "1rem" }}>
                          -{CURRENCY}{dpRedemptionValue.toFixed(2)}
                        </Text>
                      </TextWrapper>
                    )}

                    {/* ── Remaining to pay ── */}
                    <TextWrapper style={{ marginTop: 16, borderTop: "2px solid #222", paddingTop: 10 }}>
                      <Bold><h3>{t("shop_checkout_remaining_to_pay")}</h3></Bold>
                      <Price className={`${cartType} total-price`}>
                        <h3>
                          {CURRENCY}
                          {parseFloat(calcFinalTotal()).toFixed(2)}
                        </h3>
                      </Price>
                    </TextWrapper>
                  </div>

                </CalculationWrapper>
	              {/*{showSlot &&*/}
	              {/*selectedAddress &&*/}
	              {/*cartType !== "express" &&*/}
	              {/*hideCashOnDelivery ? (*/}
	              {/*	<ProvinceDeliveryDetails>*/}
	              {/*    <p className="title">*/}
	              {/*      <span className="mr-2"><CarDeliveryIcon color="#9cc54b" width="40px" height="40px"/></span>*/}
	              {/*      {t("shop_checkout_province_delivery_details_title")}*/}
	              {/*    </p>*/}
	              {/*		<p className="description">*/}
	              {/*      {t("shop_checkout_province_delivery_details_desc")}*/}
	              {/*		</p>*/}
	              {/*	</ProvinceDeliveryDetails>*/}
	              {/*) : null}*/}
              </OrderInfo>
            </Sticky>
          </CartWrapper>
          <CheckoutInformation>
            {/* DeliveryAddress */}
            <InformationBox className="address" id="address">
              <Heading className={cartType}>
                {t("setting_shop_addresses")}
              </Heading>
              <ButtonGroup>
                <RadioGroup
                style={{"justify-content": "center"}}
                  items={
                    props.user_address != undefined ? props.user_address : []
                  }
                  containerClassName="delivery-address"
                  component={(item) => (
                    <RadioCard
                      id={item.address_id}
                      key={item.address_id ? item.address_id : item.id}
                      title={item.nick_name}
                      firstName={item.first_name}
                      lastName={item.last_name ? item.last_name : null}
                      value={item.address_id}
                      content={item.area_details}
                      house_number={item.house_number}
                      apartment_name={item.apartment_name}
                      street_details={item.street_details}
                      mobile_number={item.mobile_number}
                      country_code={item.country_code}
                      city={item.city}
                      landmark={item.landmark}
                      pin_code={item.pin_code}
                      commune={item.commune}
                      district={item.district}
                      house_and_street={item.house_and_street}
                      delivery_instructions={item.delivery_instructions}
                      name="address"
                      checked={selectedAddress === item.address_id}
                      onChange={() => {
                        setChecked(1);
                        setAddressIsInRange(item.isInRange);
                        setIsInvalid({ isTrue: false, msg: "" });

                        setSelectedAddress(item.address_id);
                        let user = localStorage.getItem("user");
                        let parsedUser = JSON.parse(user);
                        let cust_id = parsedUser.cust_id;
                        props.moveToCheckout({
                          cust_id: cust_id,
                          store_id: 1,
                          order_id: localStorage.getItem("order_id"),
                          address_id: item.address_id,
                          type: cartType === "express" ? 1 : 0,
                        });

                        // Re-fetch payment methods after address change to check COD availability
                        setTimeout(() => {
                          fetchPaymentMethods();
                        }, 500);
                      }}
                      isSelected={isChecked}
                      onEdit={() => handleEditDelete(item, "edit", "address")}
                      onDelete={() =>
                        handleEditDelete(item, "delete", "address")
                      }
                    />
                  )}
                  secondaryComponent={
                    <Button
                      className={`addButton ${cartType} no-bg`}
                      title={t("button_add_new", false)}
                      icon={<Plus width="10px" />}
                      iconPosition="left"
                      colors="primary"
                      size="small"
                      variant="textButton"
                      type="button"
                      intlButtonId="addNew"
                      onClick={() =>
                        handleModal(null,null,"create")
                      }
                    />
                  }
                />
              </ButtonGroup>
            </InformationBox>

            {/* DeliverySchedule */}
            {showSlot && cartType !== "express" && (
              <InformationBox id="slot">
                <DeliverySchedule>
                  <Heading className={cartType}>
                    {t("shop_checkout_delivery_schedule_title")}
                  </Heading>

                  <AvailableDeliverySlotCheckoutPage
                    show={showSchedule}
                    handleCloseDialog={handleDeliverySlotCloseModal}
                    delivery_slots={props.delivery_slots}
                    twodslots={twodslots}
                    allSLOTS={allSLOTS}
                    selectedSlot={selectedSlot}
                    onSlotSelected={onSlotSelected}
                    all_timings={props.all_timings}
                    removeProduct = {removeProduct}
                    setRemoveProduct={setRemoveProduct}
                    grossTotal={grossTotal}
                    pageName="checkout"
                    props={props}
                    selectedAddress={selectedAddress}
                    setDeliverySlots={setDeliverySlots}
                    externalCourier={externalCourier}
                    setExternalCourier={setExternalCourier}
                  />
                  {selectedSlot ? (
                    <>
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          setShowSchedule(true);
                        }}
                        style={{
                          border: "1px dotted #9cc54b",
                          borderRadius: "25px",
                          padding: "30px 30px",
                          color: deliveryColor,
                          fontWeight: "700",
                          cursor: "pointer",
                        }}
                      >
                        <SubHeading>
                          {t("shop_checkout_Selected_delivery_schedule_label")}
                        </SubHeading>
	                      <span>{externalCourier ? formatSchedule() : moment(slotValidate.date).format("dddd, DD MMMM")}</span>
                      </div>
                    </>
                  ) : ( null
                  )}
                </DeliverySchedule>
              </InformationBox>
            )}

            {/* DeliveryType */}
            {
	            showSlot && selectedAddress && cartType !== "express" && (hideCashOnDelivery && !externalCourier) ? (
                <InformationBox id="delivery-option">
                  <Heading className={cartType}>
                    {t("shop_checkout_delivery_option_title")}
                  </Heading>
                  <ButtonGroupRn
                    vertical
                    className="delivery-option"
                    onChange={(e) => { 
                      handleChooseDeliveryOption(e)
                    }}
                  >
                    <DeliveryOptionsWrapper>
                      {deliveryOptions.map((item, index) => {
                        return (
                          <ToggleButton
                            type="radio"
                            value={item.value}
                            key={item.value}
                            checked={item.value === selfdelivery}
                            className={`btn-delivery-option ${selfdelivery === item.value ? "active" : ""}`}
                          >
                            <span>{t(item.title)}</span>
                          </ToggleButton>
                        )})}
                    </DeliveryOptionsWrapper>
                  </ButtonGroupRn>
                </InformationBox>
              ): null
            }

            {/* Pickup Points Map */}
            {
              selfdelivery === 1 && cartType !== "express" && (
                <InformationBox id="pickup-points-map">
                  <Heading className={cartType}>
                    {t("shop_checkout_select_pickup_point_title")}
                  </Heading>
                  <SubHeading className={cartType}>
                    {t("shop_checkout_select_pickup_point_subtitle")}
                  </SubHeading>
                  {selectedPickupPoint && (
                    <div style={{ padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px', marginBottom: '10px' }}>
                      <strong>{t("shop_checkout_selected_pickup_point")}:</strong> {selectedPickupPoint.name}
                      {selectedPickupPoint.address && <span> - {selectedPickupPoint.address}</span>}
                    </div>
                  )}
                  <PickupPointsMap
                    onSelectPickupPoint={handleSelectPickupPoint}
                    selectedPickupPointId={selectedPickupPoint?.id}
                    customerLatitude={selectedAddress?.latitude}
                    customerLongitude={selectedAddress?.longitude}
                  />
                </InformationBox>
              )
            }

            {/* OOS Option */}
            <InformationBox id="oos-option">
              <Heading className={cartType}>
                {t("shop_checkout_oos_option_title")}
              </Heading>
              <ButtonGroupRn
                vertical
                className="oos-option"
                onChange={(e) => { 
                  handleChooseOosOption(e)
                }}
              >
                <OosOptionsWrapper>
                  {oosOptions.map((item, index) => {
                    return (
                      <ToggleButton
                        type="radio"
                        value={item.value}
                        key={item.value}
                        checked={item.value === oosoption}
                        className={`btn-oos-option ${oosoption === item.value ? "active" : ""} ${cartType}`}
                      >
                        <div className="content">
                          <p className="title">{t(item?.title)}</p>
                          <p className="desc">{t(item?.description)}</p>
                        </div>
                      </ToggleButton>
                    )})}
                </OosOptionsWrapper>
              </ButtonGroupRn>
              </InformationBox>

            {/* Contact number */}
            <InformationBox>
              <Heading className={cartType}>
                {t("shop_checkout_comment_title")}
              </Heading>
              <ButtonGroup className={cartType}>
                <TextField
                  id="Comments"
                  as="textarea"
                  placeholder={t("shop_checkout_comment_hint", false)}
                  value={comment}
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                />
              </ButtonGroup>
            </InformationBox>

            {/* PaymentOption */}
            <InformationBox id="payment">
              <Heading className={cartType}>
                {t("shop_checkout_payment_title")}
              </Heading>
                <div className="coupon-pay-wrapper">
                  <div className={`coupon-icon-wrapper ${cartType}`}>
                    {t("shop_checkout_list_coupon_title")}
                  </div>

                  {couponFetching ? <Spinner className="d-block mx-auto my-4" animation="border" style={{ color: `${props.cartType === "express" ? "#e83e8c" : "#9cc54b"}` }} /> :
                  listCoupon.length > 0 ? <CouponListWrapper className={`coupon-pay-btn ${cartType}`}>
                  <FormControl component="fieldset">
                    <MRadioGroup row aria-label="position" name="coupon code" onChange={(e) => hanldeChangeCoupon(e)}>
                      {firstCoupon && firstCoupon?.can_apply && <CouponCodeItem disabled={isSearchingCoupong || selectedCode} md={12} className="d-block">
                        <FormControlLabel
                            checked={firstCoupon.code === defaultCoupon}
                            disabled={isSearchingCoupong || selectedCode}
                            value={firstCoupon.code}
                            control={<CustomRadio/>}
                            label={
                              <div>
                                <Typography
                                    variant="body1"
                                    style={{
                                      color: firstCoupon.can_apply ? "black" : "",
                                      fontWeight: firstCoupon.can_apply ? "500" : "",
                                    }}
                                >
                                  {firstCoupon.name} (
                                  {firstCoupon?.discountPercentage
                                      ? firstCoupon?.discountPercentage + " % "
                                      : firstCoupon?.discountFixedPrice
                                          ? CurrencyFormat(firstCoupon?.discountFixedPrice)
                                          : "-"}
                                  )
                                </Typography>
                                <div className="title">
                                  {t("valid_till")} {moment(firstCoupon?.validTo).format("DD/MM/YYYY")}
                                </div>
                              </div>
                            }
                        />
                      </CouponCodeItem>}

                      {/* Remaining Coupons - Visible only when 'See More' is clicked */}
                      {showAll &&
                          <>
                          {/* Divider Below the First Coupon */}
                            {!!firstCoupon.can_apply && <div style={{padding: "10px", width: "100%"}}>
                              <Divider variant="middle"/>
                            </div>}
                            {(!!firstCoupon.can_apply ? remainingCoupons : listCoupon).map((e, idx) => (
                                <div key={idx}>
                                  <CouponCodeItem disabled={isSearchingCoupong || selectedCode} md={12}
                                                  className="d-block">
                                    <FormControlLabel
                                        checked={e.code === defaultCoupon}
                                        disabled={isSearchingCoupong || selectedCode}
                                        value={e.code}
                                        control={<CustomRadio/>}
                                        label={
                                          <div>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                  color: e.can_apply ? "black" : "",
                                                  fontWeight: e.can_apply ? "500" : "",
                                                }}
                                            >
                                              {e.name} (
                                              {e?.discountPercentage
                                                  ? e?.discountPercentage + " % "
                                                  : e?.discountFixedPrice
                                                      ? CurrencyFormat(e?.discountFixedPrice)
                                                      : "-"}
                                              )
                                            </Typography>
                                            <div className="title">
                                              {t("valid_till")} {moment(e?.validTo).format("DD/MM/YYYY")}
                                            </div>
                                          </div>
                                        }
                                    />
                                  </CouponCodeItem>
                                </div>
                            ))}
                          </>
                      }

                      {/* Show More / Show Less Button */}
                      {remainingCoupons.length > 0 && (
                          <CouponCodeItem onClick={() => setShowAll(!showAll)} style={{marginLeft:"45px", color:"#9cc54b", cursor:"pointer"}}>
                            {showAll ? t("see_less") : t("see_more")}
                          </CouponCodeItem>
                      )}
                      <CouponCodeItem
                          disabled={isSearchingCoupong || selectedCode}
                          md={12}
                          key={"coupon-code"}
                          className="d-block"
                      >
                        <FormControlLabel
                            style={{width: "100%"}}
                            value="input_code"
                            disabled={isSearchingCoupong || selectedCode}
                            checked={defaultCoupon === "input_code"}
                            control={<CustomRadio/>}
                            label={
                              <div className="coupon-pay-btn-content w-100">
                                <input
                                    id="Code"
                                    type="textarea"
                                    placeholder={t("shop_checkout_input_coupon_hint", false)}
                                    value={defaultCoupon === "input_code" ? couponCode : ""}
                                    disabled={isSearchingCoupong || selectedCode}
                                    className={
                                      cartType.toString() === "express w-100"
                                          ? "express-border-color w-100"
                                          : "w-100"
                                    }
                                    onFocus={() => {
                                      setDefaultCoupon("input_code");
                                    }}// Set the radio to "input_code" when focusing
                                    onChange={(e) => {
                                      setCouponCode(e.target.value);
                                      setDefaultCoupon("input_code"); // Ensure the radio is checked when typing
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.keyCode === 13) {
                                        setShow(false);
                                        e.preventDefault();
                                      }
                                    }}
                                />
                              </div>
                            }
                        />
                      </CouponCodeItem>
                    </MRadioGroup>
                  </FormControl>
                  {selectedCode && (
                      <CouponBoxWrapper>
                        <CouponCode>
                          {t("shop_checkout_popup_coupon_applied")}
                        </CouponCode>
                      </CouponBoxWrapper>
                  )}
                  <Col className="apply_button">
                    {!selectedCode ? (
                        <ButtonApply
                            disabled={isSearchingCoupong}
                            onClick={(e) => handleSearchCouponCode(couponCode.trim())}
                        >
                          {isSearchingCoupong ? (
                              <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                              />
                          ) : null}

                          <span className="pl-2 pr-2">
                                  {t("shop_checkout_apply_coupon_button")}
                              </span>
                        </ButtonApply>
                    ) : (
                        <ButtonRemove onClick={handleRemoveCoupon} className="">
                              <span className="pl-2 pr-2">
                                  {t("shop_checkout_remove_coupon_button")}
                              </span>
                        </ButtonRemove>
                    )}
                  </Col>
                </CouponListWrapper>
                  : <div className={`coupon-pay-btn ${cartType}`}>
                    <div className="coupon-pay-btn-content">
                      <input
                        id="Code"
                        type="textarea"
                        placeholder={t(
                          "shop_checkout_input_coupon_hint",
                          false
                        )}
                        value={couponCode}
                        disabled={isSearchingCoupong || selectedCode}
                        className={
                          cartType.toString() === "express"
                            ? "express-border-color"
                            : ""
                        }
                        onChange={(e) => {
                          setCouponCode(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if(e.keyCode == 13) {
                            setShow(false);
                            e.preventDefault();
                          }
                        }}
                      />
                      {!selectedCode ? (
                        <ButtonApply
                          disabled={isSearchingCoupong}
                          onClick={(e) => handleSearchCouponCode(couponCode.trim())}
                        >
                          {isSearchingCoupong ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : null}

                          <span className="pl-2 pr-2">
                            {t("shop_checkout_apply_coupon_button")}
                          </span>
                        </ButtonApply>
                      ) : (
                        <ButtonRemove onClick={handleRemoveCoupon} className="">
                          <span className="pl-2 pr-2">
                            {t("shop_checkout_remove_coupon_button")}
                          </span>
                        </ButtonRemove>
                      )}
                    </div>
                  {selectedCode && (
                      <CouponBoxWrapper>
                        <CouponCode>
                          {t("shop_checkout_popup_coupon_applied")}
                        </CouponCode>
                      </CouponBoxWrapper>
                    )}
                   </div>
                  }
                </div>
              <ButtonGroupRn
                vertical
                className="payment-option"
                onChange={(e) => { 
                  if(e.target.value !== ""){
                    paymentOptionChoose(e.target.value);
                    logPaymentInfo(items,'pay online')
                  }
                  if(e.target.value == ""){
                    setIsPayOnline(true)
                    paymentOptionChoose('0');
                    logPaymentInfo(items,'pay online')
                  }else if(e.target.value === "cod"){
                    setIsPayOnline(false)
                    logPaymentInfo(items,'pay on delivery')
                  }
                }}
              >
              {(totalWalletAmount !== null && isDisplayWallet) || (dpBalance !== null && isDisplayDelipoints) ? (
                <div className="wallet-pay-wrapper">
                  <div className={`wallet-icon-wrapper ${cartType}`}>
                    {t("shop_checkout_payment_wallet_and_delipoints_title")}
                  </div>
                  <div style={{ border: "1px solid #e1e1e1", borderRadius: "8px", overflow: "hidden", paddingTop: "10px", paddingBottom: "10px" }}>
                    {totalWalletAmount !== null && isDisplayWallet ? (
                      <label
                        className="wallet-pay-btn"
                        style={{
                          border: "none",
                          margin: 0
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setWalletChecked(prev => !prev);
                          setTotalWalletAmount(props.wallet.amount);
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          id="walletPayment"
                          label=""
                          checked={walletChecked}
                          onChange={(e) => {
                            e.stopPropagation();
                            setWalletChecked(prev => !prev);
                            setTotalWalletAmount(props.wallet.amount);
                          }}
                          onClick={(e) => e.stopPropagation()}
                          style={{ cursor: "pointer" }}
                        />
                        <div className="btn-title">
                          {`Use my wallet balance ($${parseFloat(totalWalletAmount || 0).toFixed(2)})`}
                        </div>
                      </label>
                    ) : null}
                    {/* ── Button 1: Item redemption (disabled when Button 2 is checked) ── */}
                    {dpBalance !== null && isDisplayDelipoints && hasRedeemItems && (
                      <label
                        className="wallet-pay-btn"
                        style={{ border: "none", margin: 0, opacity: (delipointsChecked && !itemsRedeemChecked) ? 0.5 : 1, cursor: (delipointsChecked && !itemsRedeemChecked) ? "not-allowed" : "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!(delipointsChecked && !itemsRedeemChecked)) setItemsRedeemChecked(prev => !prev);
                        }}
                      >
                        <Form.Check
                          type="checkbox"
                          id="itemsRedeemPayment"
                          label=""
                          checked={itemsRedeemChecked}
                          disabled={delipointsChecked && !itemsRedeemChecked}
                          onChange={(e) => {
                            e.stopPropagation();
                            if (!(delipointsChecked && !itemsRedeemChecked)) setItemsRedeemChecked(prev => !prev);
                          }}
                          onClick={(e) => e.stopPropagation()}
                          style={{ cursor: (delipointsChecked && !itemsRedeemChecked) ? "not-allowed" : "pointer" }}
                        />
                        <div className="btn-title">
                          {`DeliPoints redemption (${
                            (items ?? []).reduce((sum, item) => sum + parseFloat(item.store_item_infos?.[0]?.dp_points ?? 0) * parseInt(item.dp_redeem_quantity ?? 0), 0)
                          } pts - $${itemsRedemptionAmount.toFixed(2)})`}
                        </div>
                      </label>
                    )}

                    {/* ── Button 2: Leftover Points (remaining balance applied to order total) ── */}
                    {dpBalance !== null && isDisplayDelipoints ? (() => {
                      const minRedemption = parseFloat(dpSettings?.minimum_redemption ?? 0);
                      const valuePerPoint = parseFloat(dpSettings?.payment_value_per_point ?? 0);
                      const itemPts = itemsRedeemChecked
                        ? (items ?? []).reduce((sum, item) => sum + parseFloat(item.store_item_infos?.[0]?.dp_points ?? 0) * parseInt(item.dp_redeem_quantity ?? 0), 0)
                        : 0;
                      const remainingBalance = Math.max((dpBalance ?? 0) - itemPts, 0);
                      const pointsNeeded = valuePerPoint > 0
                        ? Math.min(Math.ceil(dpRedemptionValue / valuePerPoint), remainingBalance)
                        : remainingBalance;
                      const remainingAfterPromoAndWallet = Math.max(
                        grossTotal
                          - (itemsRedeemChecked ? itemsRedemptionAmount : 0)
                          - (walletChecked && props.wallet ? (props.wallet.amount ?? 0) : 0),
                        0
                      );
                      const canRedeem = props.deliveryCharge !== undefined && remainingAfterPromoAndWallet > 0 && (minRedemption <= 0 || remainingBalance >= minRedemption);
                      return (
                        <label
                          className="wallet-pay-btn"
                          style={{ border: "none", margin: 0, opacity: canRedeem ? 1 : 0.5, cursor: canRedeem ? "pointer" : "not-allowed" }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (canRedeem) setDelipointsChecked(prev => !prev);
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            id="delipointsPayment"
                            label=""
                            checked={delipointsChecked}
                            disabled={!canRedeem}
                            onChange={(e) => {
                              e.stopPropagation();
                              if (canRedeem) setDelipointsChecked(prev => !prev);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            style={{ cursor: canRedeem ? "pointer" : "not-allowed" }}
                          />
                          <div className="btn-title">
                            {`Use ${pointsNeeded} extra DeliPoints ($${dpRedemptionValue.toFixed(2)})`}
                            {!canRedeem && minRedemption > 0 && (
                              <span style={{ display: "block", fontSize: "0.78rem", color: "#e53935", marginTop: "3px" }}>
                                {itemPts > 0
                                  ? `${remainingBalance} pts remaining after item redemption — min. ${minRedemption} pts required`
                                  : `Min. ${minRedemption} ${t("shop_checkout_payment_points_title")} required to redeem`
                                }
                              </span>
                            )}
                          </div>
                        </label>
                      );
                    })() : null}
                  </div>
                </div>
              ) : null}
                {/* Payment Methods Section */}
                <div className="choose-payment-wrapper" style={{ marginTop: '20px' }}>
                  <div className={`choose-payment-icon-wrapper ${cartType}`}>
                    {t("choose_your_payment")}
                  </div>
                  {(!props.user_address || props.user_address.length === 0) ? (
                    <div style={{padding: '20px 0', textAlign: 'center', color: '#888'}}>
                      <p style={{fontSize: 14}}>
                        {t("shop_checkout_no_address_payment_hint") || "Please add a delivery address to see payment options."}
                      </p>
                    </div>
                  ) : (
                    <div className="choose-payment-container">
                    {/* COD Payment Method */}
                    {!hideCashOnDelivery && codMethodData && (
                      <div className="cod-payment-method" style={{ position: 'relative' }}>
                        <PaymentMethodItem
                          method={{
                            bic: 'CASH',
                            title: codMethodData.title || t("shop_checkout_cash_on_delivery_option"),
                            img_url: codMethodData.img_url || cashIcon,
                            payment_type: 'offline'
                          }}
                          isSelected={!selectedPaymentType && paymentMethod === "cod"}
                          onSelect={handleSelectCOD}
                          disabled={isDisabled || isLoadingPaymentMethods}
                          cartType={cartType === "express" ? "express" : "normal"}
                        />
                        <IconButton
                          onClick={handleCODInfoClick}
                          size="small"
                          style={{
                            position: 'absolute',
                            right: '45px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#9cc54b',
                            padding: '4px'
                          }}
                        >
                          <InfoIcon style={{ fontSize: '20px' }} />
                        </IconButton>
                        <Popover
                          open={codInfoOpen}
                          anchorEl={codInfoAnchorEl}
                          onClose={handleCODInfoClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                          PaperProps={{
                            style: {
                              maxWidth: '300px',
                              borderRadius: '8px',
                              boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                            }
                          }}
                        >
                          <Box p={2}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
	                            {codMethodData.info.title}
                            </Typography>
                            <Typography variant="body2" style={{ color: '#666', lineHeight: 1.6 }}>
	                            {codMethodData.info.description}
                            </Typography>
                          </Box>
                        </Popover>
                      </div>
                    )}

                    {/* Online Payment Methods - using existing listPaymentMethod which includes fallback ABA */}
                    <PaymentMethodList
                      paymentMethods={listPaymentMethod}
                      selectedMethod={selectedPaymentType}
                      onSelectMethod={handleSelectPaymentMethod}
                      isLoading={isLoadingPaymentMethods}
                      disabled={isDisabled}
                      cartType={cartType === "express" ? "express" : "normal"}
                      title=""
                      t={t}
                    />
                  </div>
                  )}
                </div>
              </ButtonGroupRn>
            </InformationBox>

            <CheckoutSubmit
              className={
                enableCheckOutButton ? "btn-checkout enable" : "btn-checkout"
              }
            >
              <Button
                onClick={(e) => handleSubmit(e)}
                type="button"
                disabled={loading}
                title={t("shop_checkout_pay_button", false)}
                intlButtonId="proceesCheckout"
                loader={<Loader className={cartType} />}
                isLoading={loading}
              />
            </CheckoutSubmit>
            {/* </InformationBox> */}
          </CheckoutInformation>
        </CheckoutContainer>
      </CheckoutWrapper>
      <>
          
        {/* Validation Toast */}
        <Toast
          show={isInvalid.isTrue}
          onClose={() => setIsInvalid({isTrue: false})}
          animation
          delay={6000}
          autohide
          className="bg-danger"
          style={{
            position: 'fixed',
            top: 70,
            right: 20,
            zIndex: 1051,
            width: "fit-content",
          }}
        >
          <Toast.Header closeButton>
            <p
              style={{
                display: "block",
                marginRight: "2rem",
                padding: "0.75rem 0.25rem",
                fontSize: "1rem",
                color: "#333"
              }}>
              {isInvalid.msg}
            </p>
          </Toast.Header>
      </Toast>

        <Modal
          show={modalshow}
          onHide={() => {
            setModalShow(false);
          }}
          // dialogClassName="modal-lg"
          aria-labelledby="example-custom-modal-styling-title"
          size="sm"
          animation={true}
          centered
        >
          <Animation options={defaultOptions} height={180} width={180} />
          <div
            style={{
              fontSize: 20,
              textAlign: "center",
              margin: 10,
              marginTop: 18,
              color: "#222",
            }}
          >
            {t("shop_checkout_alert_success_order")}
          </div>
        </Modal>

        <SimpleMessageDialog
          show={showError}
          message={errorMessage}
          showHeader={true}
          headerLabel={dialogHeaderLabel}
          onClose={handleErrorModalClose}
        />
	      <CheckoutFormV2
          dialogStatus={showPaymentModal}
          paymentMethod={paymentMethod}
          placeOrderStatus={placeOrderStatus}
          handleClose={handleHideShowCheckOutDialog}
          items={items}
          paymentData={props.checkoutdata}
          orderId={localStorage.getItem("order_id")}
        />

        {/* Dialog For Visa/Mater Card to confirm whether customer want to pay with existing card or new one */}
        <Modal
          backdrop='static'
          show={showDialog}
          centered
          onHide={() => {
            setShowDialog(false);
            setHistoryCard([]);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Pay with Visa/Master Card</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form className="w-full d-flex flex-column">
              <p className="h5 mb-3">Your card{ historyCard.length > 1 && 's' } history:</p>
              <ButtonGroupRn
                vertical
                onChange={(e) => handleChangeVisaOldCard(e.target.value)}
              >
                <HistoryCardsWrapper>
                {
                  loading ? <Spinner animation="border" variant="secondary" className="m-2 mx-auto"/> :
                    historyCard.map((item, index) => {
                      return (
                        <ToggleButton
                          type="radio"
                          disabled={item.is_expired === 1}
                          checked={selectedIndex == index}
                          value={index}
                          className={`toggle-btn ${isExpress}`}
                        >
                          <img src={item.account_logo} alt={item.account_name} />
                          <div className="card-content">
                            <strong className="text-dark">{item.holder_name}</strong>
                            <p className="card-number"><span className="text-muted card-label">Card Number: </span>{item.account_number}</p>
                            <div className="expiry-content">
                            {
                              item.is_expired === 1 ?
                                <span className="text-danger">Expired</span>
                                : <>
                                    <p>Expiry Date: </p>
                                    <span className="text-muted">{item.month < 10 ? 0 : null}{item.month}/{item.year}</span>
                                </>
                            } 
                            </div>
                          </div>
                        </ToggleButton>
                      )
                    })
                }
                </HistoryCardsWrapper>
              </ButtonGroupRn>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              title="Add New"
              size="small"
              className={`${cardLoading ? "bg-secondary" : 'bg-info'}`}
              disabled={cardLoading}
              isLoading={cardLoading}
              loader={<Spinner animation="border" size="sm" />}
              style={{ width: '6em' }}
                onClick={(e) => handlePaymentWithNewCard(e)}
            /> 
            {
              isOldCardExpired === false && cardToken ? 
                <Button
                  type='button'
                  title="Next"
                  size="small"
                  variant={`${oldCardLoading ? "secondary" : 'success'}`}
                  disabled={oldCardLoading}
                  isLoading={oldCardLoading}
                  loader={<Spinner animation="border" size="sm" />}
                  style={{ width: '6em' }}
                  onClick={(e) => handlePaymentWidthOldCard(e)}
                /> :
              null
            }
          </Modal.Footer>
        </Modal>

        {/*
          ============================= Modal confirm backet amount lower than minimum backet amount of coupon code ======================
        */}

        <Modal
            show={isShowModalErrorMinBacketAmount}
            onHide={handleCloseModalConfirmErrorMinBacketAmount}
            dialogClassName="modal-90w authModal"
            aria-labelledby="example-custom-modal-styling-title"
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("shop_delivery_confirmation_button")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {errorMinBasketAmountMessage}
          </Modal.Body>
          <Modal.Footer>
            <Button
                title={t("shop_order_list_button_ok_dialog", false)}
                variant="primary"
                onClick={handleCloseModalConfirmErrorMinBacketAmount}
            />
          </Modal.Footer>
        </Modal>

        {/* 
          ============================= Modal confirm no coupon code found ======================
        */}

        <Modal
          show={isShowModalConfirmNoFoundCouponCode}
          onHide={(e) => setIsShowModalConfirmNoFoundCouponCode(false)}
          dialogClassName="modal-90w authModal"
          aria-labelledby="example-custom-modal-styling-title"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("shop_delivery_confirmation_button")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{message}</Modal.Body>
          <Modal.Footer>
            <Button
              title={t("shop_order_list_button_ok_dialog", false)}
              variant="primary"
              onClick={(e) => setIsShowModalConfirmNoFoundCouponCode(false)}
            />
          </Modal.Footer>
        </Modal>

        {/* 
          ============================== Modal public coupon list =================================
        */}
        <Modal
          show={show}
          onHide={() => {
            setShow(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("shop_checkout_popup_coupon_title_label")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              <Card.Body>
                <ListGroup variant="flush">
                  {couponList.length > 0 &&
                    couponList.map((coupon, idx) => {
                      let user = localStorage.getItem("user");
                      let parsedUser = JSON.parse(user);
                      let cust_id = parsedUser.cust_id;
                      let restricted_coupons = restrictedrange(1753, 1903);
                      if (
                        cust_id === 228 &&
                        restricted_coupons.indexOf(coupon.id)
                      ) {
                        return null;
                      } else {
                        return (
                          <ListGroup.Item
                            key={coupon.name}
                            id={coupon.code}
                            action
                            onClick={(e) => handleCouponSelected(coupon)}
                          >
                            <p style={{ color: "red" }}>{coupon.code}</p>
                            <p>{coupon.name}</p>
                            <p style={{ color: deliveryColor }}>
                              {coupon.description}
                            </p>
                          </ListGroup.Item>
                        );
                      }
                    })}
                </ListGroup>
              </Card.Body>
            </Card>
          </Modal.Body>
        </Modal>
          {/* model open business hours */}
        <Modal
          show={openModalHours}
          onHide={() => {
            handleCloseNormalHour(openModalHours)
          }}
          dialogClassName="modal-90w authModal"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("businessHours")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center mb-4">
              <span className="mr-2"><IconAlarm color="black" width="20px" height="20px"/></span>
                <span
                  style={{
                    fontSize: 21,
                    fontWeight: "bold"
                  }}
                >
                  {t("hours")}
                  {itemForToday && itemForToday.is_available !== false ?
                    <p 
                      style={{
                        fontSize: 16,
                        color: "#9cc54b"
                      }}
                    >
                      {t("shopOpening")}
                    </p>
                  :
                    <p 
                      className='text-danger'
                      style={{
                        fontSize: 16
                      }}
                    >
                      {t("shopClosedNow")}
                    </p>
                  }
                </span>
            </div>
            {normalOpenHours.length > 0 && normalOpenHours.map((item, idx) => (
              <Row key={idx}>
                <Col xs={4} md={6} sm={6} xl={6}>
                  <p
                    style={{
                      fontWeight: `${item.is_today === true ? 'bold' : 500}`,
                      padding: '2px 0px'
                    }}
                  >{item.day}</p>
                </Col>
                {item.is_available === true ?
                  <Col xs={8} md={6} sm={6} xl={6}>
                    <p
                      style={{
                        fontWeight: `${item.is_today === true ? 'bold' : 500}`,
                        padding: '2px 0px'
                      }}
                    >{`${moment(item.start_time, 'hh:mm A').format('hh:mm A')} - ${moment(item.end_time, 'hh:mm A').format('hh:mm A')}`}</p>
                  </Col>
                :
                  <Col xs={6} md={6} className='text-danger'>
                    <p
                      style={{
                        fontWeight: `${item.is_today === true ? 'bold' : 500}`
                      }}
                    >Closed</p>
                  </Col>
                }
              </Row>
            ))}
          </Modal.Body>
        </Modal>

        {/* check ip address */}
        {waitingIpFetching || (ipDataUser == undefined) || ipDataUser == null || !ipDataUser.countryName ? null : (
          <DialogComponent
            open={ipModalSessions && showIpReginModal}
            onClose={handleCloseIpReginModal}
            title={t('ip_regin_title', false, { path: ipDataUser.countryName })}
            description={`${t('ip_regin_description')}`}
            IconComponent={ErrorOutlineIcon}
            buttonLabel={t('group_menu_dialog_change_name_button_ok')}
            buttonColor="#9cc54b"
            titleColor="#9cc54b"
            iconColor="#9cc54b"
          />
        )}

        <DialogComponent
          open={showErrorModal}
          onClose={handleToggleShowErrorModal}
          title={t(checkFailerBedgetwayCode(pay_response_gatewayCode).label)}
          description={t(pay_response_gatewayCode ? pay_response_gatewayCode : "OTHER_ERRORS")}
          IconComponent={checkFailerBedgetwayCode(pay_response_gatewayCode).icon}
          buttonLabel={t('group_menu_dialog_change_name_button_ok')}
          buttonColor="#9cc54b"
          titleColor={checkFailerBedgetwayCode(pay_response_gatewayCode).color}
          iconColor={checkFailerBedgetwayCode(pay_response_gatewayCode).color}
        />
      </>

      {/*//address modal*/}
      {addressModal &&
          <CustomerAddress
            props={props}
            open={addressModal}
            handleToggleModal={handleModal}
            selectedAddressToUpdate={selectedAddressToUpdate}
            setSelectedAddressToUpdate={setSelectedAddressToUpdate}
            type={addressModalType}
            handleSelectAddressWhenCreateNew={handleSelectAddressWhenCreateNew}
          />
      }
    </form>
  );
};

export default CheckoutWithSidebar;
